{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Tabbladen voor taalkeuze van het formulier"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "U heeft niet voldoende rechten om toegang te krijgen tot deze pagina."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Kalender",
    "URL_WITH_EVENT": "{description} \n Word lid van het webevenement: {url}"
  },
  "ANONYMOUS": "Anoniem",
  "API_SAUCE": {
    "CANCEL_ERROR": "Verzoek is geannuleerd.",
    "CLIENT_ERROR": "Oeps, er is een onverwachte fout opgetreden.",
    "CONNECTION_ERROR": "Server niet beschikbaar.",
    "NETWORK_ERROR": "Netwerk niet beschikbaar.",
    "SERVER_ERROR": "Oeps, er is een onverwachte fout opgetreden.",
    "TIMEOUT_ERROR": "De server reageerde niet op tijd."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "Ongepubliceerd",
    "PUBLICATION_ALERT": "Gepland op {date} om {time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Eigenaar foto",
    "TITLE": "Eigenaar"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Kies een beheerder",
    "TITLE": "Wijs deze bijdrage toe"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "We konden deze bijlage niet wissen.",
      "TITLE": "Fout - "
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Ik doe mee",
    "ATTENDING": "Geregistreerd"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "Ik ga akkoord met het <terms>privacybeleid</terms> van {spaceName}.",
    "ACCEPT_SPACE_TERMS": "Ik ga akkoord met de <privacy>Gebruiksvoorwaarden</privacy> van {spaceName}",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "Ik ga akkoord met het <privacy>Privacybeleid</privacy> en de <terms>Gebruiksvoorwaarden</terms> van {spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "Ik ga akkoord met de {privacy} en de {terms} van Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "Meld je aan bij {provider}",
    "AUTH_LIST_TITLE": "Authenticatiediensten van derden",
    "BACKGROUND_ALT": "Achtergrond",
    "CONTINUE_WITHOUT_SIGNUP": "Doorgaan zonder account",
    "DELETE_TOAST": "De authenticatiedienst van derden is verbroken",
    "DESCRIPTION": "Uw registratie op Fluicity Engage stelt u in staat deel te nemen aan raadplegingen over {spaceName} en geeft u toegang tot andere raadplegingen die op Fluicity Engage worden georganiseerd. Om meer te weten te komen over hoe wij uw persoonsgegevens beheren en om uw rechten uit te oefenen, kunt u ons <b>Privacybeleid raadplegen.</b>",
    "EMAIL_PLACEHOLDER": "voorbeeld@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "Door lid te worden van <strong>{spaceName}</strong>, wordt u op de hoogte gebracht van de nieuwste raadplegingen en nieuws.<br></br><br></br>Je kunt ook beter helpen begrijpen of de activiteit representatief is voor de wereldwijde bevolking door wat informatie te delen:",
      "TITLE": "Word lid van {spaceName}!"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Stel een wachtwoord in om deze authenticatiedienst van derden te verwijderen.",
      "DELETE_AUTH_FAILED": "We konden deze authenticatiedienst van derden niet verwijderen.",
      "INVALID_EMAIL": "Het formaat van uw e-mail adres is ongeldig.",
      "NO_ASSOCIATED_ACCOUNT": "Er is geen rekening mee verbonden.",
      "REQUIRED_CHECKBOX": "U moet dit vakje aankruisen.",
      "REQUIRED_EMAIL": "U moet een e-mailadres invullen.",
      "REQUIRED_FIRST_NAME": "U moet een voornaam invoeren.",
      "REQUIRED_LAST_NAME": "U moet een naam invullen.",
      "REQUIRED_PASSWORD": "U moet een wachtwoord invullen.",
      "SHORT_PASSWORD": "Het wachtwoord moet ten minste {count} tekens lang zijn."
    },
    "FACEBOOK_LOAD_ERROR": "Het lijkt erop dat een extensie op uw browser voorkomt dat wij de Facebook-verificatie gebruiken. Gelieve de extensie uit te schakelen als u deze functie wenst te gebruiken.",
    "FIRST_NAME_PLACEHOLDER": "Voorbeeld: Jan",
    "FORGOT_PASSWORD": "Bent u uw wachtwoord vergeten?",
    "HAS_ACCOUNT": "Heb je al een account? ",
    "HAS_SIGNED_IN": "Je bent ingelogd op {spaceName}!",
    "LAST_NAME_PLACEHOLDER": "Voorbeeld: Jansen",
    "LOGIN": "Meld je aan.",
    "NAME_PREVIEW": "Andere gebruikers zullen je zien als een:",
    "NO_ACCOUNT": "Nog geen account?",
    "OAUTH_BUTTONS": {
      "CSAM": "Doe mee met CSAM"
    },
    "PAGE_TITLE": "Meld je aan.",
    "SIGNUP": "Account aanmaken",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Helpt ons beter te begrijpen of de activiteit van het platform representatief is voor de wereldbevolking. Deze informatie worden alleen gebruikt voor verificatie en statistische doeleinden met betrekking tot de deelname.",
      "PAGE_TITLE": "Laatste stap!",
      "WELCOME_TOAST": "Gefeliciteerd, u bent geregistreerd bij {spaceName}!"
    },
    "UNLINK": "Ontkoppelen",
    "VERIFY_EMAIL": {
      "CONTENT": "Voer de ontvangen verificatiecode in op {email}.",
      "RESEND": "Ik zal je een e-mail sturen.",
      "RESEND_LINK": "Verstuur de code",
      "RESEND_SUCCESS": "Een nieuwe verificatiecode is naar u verzonden.",
      "TITLE": "Controleer uw account",
      "VERIFY_ALERT": "Controleer uw e-mailadres om deel te nemen aan alle consultaties.",
      "VERIFY_SUCCESS": "Uw account is succesvol geverifieerd."
    }
  },
  "BACK": "Terug",
  "BUTTONS": {
    "ACCEPT": "Accepteren",
    "ACCESS_CONSULTATION": "Ga naar de consultatie",
    "ACTIONS": "Handelingen",
    "ADD": "Toevoegen",
    "ADD_ATTACHMENTS": "Bestanden/afbeeldingen toevoegen",
    "ADD_NEW_IDEA": "Bijdragen",
    "CANCEL": "Annuleren",
    "CHANGE_USER": "Wijzigen van gebruiker",
    "CLEAR": "Duidelijk",
    "CLONE": "Duplicaat",
    "CLOSE": "Sluiten",
    "COMMENT": "Comment",
    "CONFIRM": "Confirmeren",
    "CONTINUE": "Doorgaan",
    "DELETE": "Verwijderen",
    "DELETE_VOTERS": "Verwijder de stemmers",
    "DRAG_DROP_ATTACHMENTS": "Sleep bestanden/afbeeldingen hierheen of klik hier",
    "EXPORT": "Export",
    "EXPORT_PARTICIPANTS": "Deelnemers exporteren",
    "EXPORT_PROPOSALS": "Exportbijdragen",
    "EXPORT_RESULTS": "Resultaten exporteren",
    "EXPORT_VOTERS": "Kiezers exporteren",
    "FILTER": "Filtreren",
    "IGNORE": "Niet nu",
    "IMPORT": "Importeren",
    "IMPORT_VIA_EXCEL": "Een Excel-bestand importeren",
    "IMPORT_VIA_FORM": "Vul het online formulier in",
    "IMPORT_VOTERS": "Voeg stemmers toe",
    "IN_PROGRESS": "Bezig…",
    "JOIN": "Meedoen",
    "LEARN_MORE": "Meer informatie",
    "NO": "Nee",
    "OPEN": "Open",
    "OPEN_IN_NEW_TAB": "Openen in nieuw tabblad",
    "PUBLISH": "Publiceren",
    "READ_MORE": "Bekijk meer",
    "REJECT_ALL": "Alles weigeren",
    "SAVE": "Registreren",
    "SETTINGS": "Instellingen",
    "SKIP": "Overgaan",
    "TRANSLATE_VIA_AI": "Vertalen via AI",
    "UPDATE": "Bijwerken",
    "UPDATE_PICTURE": "Bewerk foto",
    "UPLOAD_PICTURE": "Uploaden",
    "VERIFY": "Rekening",
    "VERIFY_EMAIL": "Mijn e-mailadres verifiëren",
    "VIEW_ANSWER": "Zie het antwoord",
    "VIEW_IDEAS": "Zie bijdragen",
    "VOTE": {
      "BUDGET": "Ik steun",
      "NOT_SUPPORT": "Ik steun niet",
      "SUPPORT": "Ik steun",
      "TOAST": {
        "CANCEL": "Uw stem is ingetrokken",
        "SUCCESS": "Uw stem is geregistreerd"
      },
      "VOTE_AGAINST": "Ik stem tegen",
      "VOTE_FOR": "Ik stem voor"
    },
    "WRITE": "Schrijven"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {Geen inhoud} one {{count} inhoud} other {{count} inhouds}}",
  "COMMENTS": {
    "AUTHOR": "Auteur",
    "CREATE": {
      "PRIVACY_WARNING": "Deze inhoud is vertrouwelijk. Alleen de auteur en de ontvangende organisatie kunnen het bekijken.",
      "SUBMIT": "Verzenden"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Een openbare opmerking achterlaten om de statuswijziging uit te leggen."
      },
      "ERROR": "Gelieven het veld te vervolledigen alvorens je het publiceert.",
      "PLACEHOLDER": "Uw opmerking",
      "SUCCESS_ANOMALY": "Je afwijking is verzonden.",
      "SUCCESS_DEMAND": "Je bericht is verzonden.",
      "SUCCESS_IDEA": "Uw opmerking is gepubliceerd.",
      "VALIDATE": "Bevestig"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "Wees de eerste om te reageren!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "Deze gebruiker wacht op uw antwoord sinds {date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "Wees de eerste om te reageren!",
      "CONTRIBUTION_ENDED": "Het overleg eindigde",
      "CONTRIBUTION_ENDED_ON": "Het overleg eindigde op {date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "Het overleg begint op {date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {Geen reactie} one {{count} Reactie} other {{count} Reacties}}",
      "COUNT_MESSAGING": "{count, plural, =0 {Geen antwoord} one {{count} Antwoord} other {{count} Antwoorden}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {Geen opmerking} one {{count} Opmerking} other {{count} Opmerkingen}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "Deze opmerking is verwijderd.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {Geen antwoorden} one {Zie {count} antwoord} other {Zie {count} antwoorden}}",
      "REPLY": "Antwoord"
    },
    "TITLE": "Reacties"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "Een hoge contrastverhouding zorgt voor toegankelijkheid voor uw gebruikers. Volgens de internationale normen (WCAG) adviseren wij u een kleur te kiezen met een verhouding van meer dan {ratio}:1 (niveau AA van de WCAG versie 2.1)",
    "TEXT": {
      "BAD": "Het contrastniveau voor deze kleur is {value}:1, wat niet in overeenstemming is met de toegankelijkheidsrichtlijnen (WCAG niveau AA)",
      "GOOD": "Contrastniveau is {value}:1 bij deze kleur. Het is boven de drempel om te voldoen aan de toegankelijkheidsrichtlijnen (WCAG niveau AA)."
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} zal cookies op uw computer plaatsen indien u van deze functie gebruik wenst te maken."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "U heeft een adblocker ingeschakeld die het afspelen van deze video verhindert. Schakel deze uit om door te gaan.",
      "CTA": "Laat de koekjes",
      "VIMEO": "Vimeo moet cookies plaatsen om een video weer te geven",
      "YOUTUBE": "Youtube moet cookies plaatsen om een video weer te geven"
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Exportbijdragen",
        "MESSAGING": "Exporteren",
        "PARTICIPATION": "Exporteren"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {Geen toewijzing} one {{count} Toewijzing} other {{count} Toewijzingen}}",
      "COMMUNICATION": "{count, plural, =0 {Geen nieuws} one {{count} Nieuws} other {{count} Nieuws}}",
      "CONSULTATION": "{count, plural, =0 {Geen overleg} one {{count} Raadpleging} other {{count} Raadplegingen}}",
      "FOLDER": "{count, plural, =0 {Geen dossiers} one {{count} Dossier} other {{count} Dossiers}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Geen inhoud} one {{count} Inhoud} other {{count} Inhoud}}",
      "FORM_RESPONSES": "{count, plural, =0 {Geen antwoord} one {{count} Antwoord} other {{count} Antwoorden}}",
      "INVITATIONS": "{count, plural, =0 {Geen uitnodigingen} one {{count} uitnodiging} other {{count} uitnodigingen}}",
      "MESSAGING": "{count, plural, =0 {Geen inhoud} one {{count} Inhoud} other {{count} Inhoud}}",
      "NEWSLETTERS": "{count, plural, =0 {Geen newsletters} one {{count} Newsletter} other {{count} Newsletters}}",
      "PARTICIPATION": "{count, plural, =0 {Geen bijdrage} one {{count} Bijdrage} other {{count} Bijdragen}}",
      "RANKING": "Rangschikking van bijdragen",
      "USER": "{count, plural, =0 {Geen gebruikers} one {{count} Gebruiker} other {{count} Gebruikers}}",
      "VOTERS": "{count, plural, =0 {Geen stemmen} one {{count} Stem} other {{count} Stemmen}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {Geen nieuws geselecteerd} one {{count} Nieuws geselecteerd} other {{count} Nieuws geselecteerd}}",
      "CONSULTATION": "{count, plural, =0 {Geen consultatie geselecteerd} one {{count} Consultatie geselecteerd} other {{count} Consultaties geselecteerd}}",
      "FOLDER": "{count, plural, =0 {Geen dossier geselecteerd} one {{count} dossier geselecteerd} other {{count} dossiers geselecteerd}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Geen inhoud geselecteerd} one {{count} inhoud geselecteerd} other {{count} inhoudsitems geselecteerd}}",
      "MESSAGING": "{count, plural, =0 {Geen inhoud geselecteerd} one {{count} Inhoud geselecteerd} other {{count} Inhoud geselecteerd}}",
      "PARTICIPATION": "{count, plural, =0 {Geen geselecteerde bijdrage} one {{count} Geselecteerde bijdrage} other {{count} Geselecteerde bijdragen}}",
      "VOTERS": "{count, plural, =0 {Aucun votant sélectionné} one {{count} Votant sélectionné} other {{count} Votants sélectionnés}} -> {count, plural, =0 {Geen geselecteerde stemmer} one {{count} Geselecteerde stemmer} other {{count} Geselecteerde stemmers}}"
    },
    "EDIT": "Bewerken",
    "EMPTY_STATE": {
      "ASSIGNMENT": "Je zal hier de inhoud vinden die aan jou is toegewezen.",
      "COMMUNICATION": "Publiceer je eerste nieuws",
      "CONSULTATION": "Publiceer uw eerste consultatie",
      "FOLDER": "Maak je eerste dossier",
      "FOLDER_CONTENT": "U vindt hier de inhoud van het dossier",
      "FORM_RESPONSES": "Hier vindt u de antwoorden op de vragenlijst.",
      "INVITATIONS": "De lijst met uitnodigingen vindt u hier.",
      "MESSAGING": "Je vindt hier berichten en anomalieën",
      "NEWSLETTER": "Maak uw eerste nieuwsbrief",
      "PARTICIPATION": "Het spijt me, ik kan deze zin niet vertalen omdat hij al in het Frans is.",
      "SEARCH": {
        "BUTTON": "Filters resetten",
        "DESCRIPTION": "Controleer of u uw zoekopdracht correct hebt gespeld of wijzig de filters.",
        "TITLE": "Geen resultaten"
      },
      "USER": "Hier vindt u de lijst van geregistreerde gebruikers.",
      "VOTERS": "U vindt hier de stemmers van de raadpleging"
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "Gemeente",
        "PLACEHOLDER": "Filtreren op gemeente"
      },
      "BLANK": "Niet opgegeven",
      "FOLDER": {
        "LABEL": "Dossier",
        "PLACEHOLDER": "Filter op dossier"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Concept",
        "SCHEDULED": "Gepland",
        "SENT": "Verzonden"
      },
      "PROF_CATEGORY": {
        "LABEL": "Sociaal-economische categorie",
        "PLACEHOLDER": "Filteren op sociaal-economische categorie"
      },
      "REGISTERED": {
        "LABEL": "Ingeschreven",
        "PLACEHOLDER": "Filteren op inschrijving",
        "REGISTERED": "Ingeschreven",
        "UNREGISTERED": "Niet ingeschreven"
      },
      "ROLES": {
        "ADMINISTRATOR": "Beheerder",
        "AUTHOR": "Auteur",
        "CITIZEN": "Gebruiker",
        "CONTRIBUTOR": "Beheerder",
        "LABEL": "Rol",
        "PLACEHOLDER": "Filter op rol"
      },
      "SEX": {
        "LABEL": "Geslacht",
        "PLACEHOLDER": "Filtreren op geslacht"
      },
      "STATUS": {
        "ANSWERED": "Niet behouden",
        "DOING": "Analyse in uitvoering",
        "DONE": "Echt gemaakt",
        "DUPLICATE": "Gegroepeerd",
        "IN_PROGRESS": "Lopende uitvoering",
        "LABEL": "Status",
        "MESSAGING": {
          "DOING": "Analyse in uitvoering",
          "DONE": "Geleverd antwoord",
          "LABEL": "Status",
          "PLACEHOLDER": "Filter op status",
          "TODO": "Ingediend"
        },
        "PLACEHOLDER": "Kies de staat.",
        "PLANNED": "Gepland",
        "REJECTED": "Geweigerd",
        "SELECTED": "Het achterhouden van",
        "TODO": "Ingediend",
        "TO_MODERATE": "Bijdrage modereren",
        "VALIDATED": "Winnaar"
      },
      "TAG": {
        "LABEL": "Onderwerp",
        "PLACEHOLDER": "Filter op onderwerp"
      },
      "TYPES": {
        "ANOMALY": "Afwijking",
        "ARTICLE": "Artikel",
        "COLLABORATIVE_DECISION": "Overleg",
        "DEMAND": "Bericht",
        "EVENT": "Evenement",
        "FOLDER": "Dossier",
        "IDEA": "Bijdrage",
        "IDEAS_REQUEST": "Oproepen tot bijdragen",
        "LABEL": "Type inhoud",
        "PARTICIPATORY_BUDGET": "Participatief budget",
        "PLACEHOLDER": "Filter op type",
        "STUDY": "Vragenlijst",
        "SURVEY": "Vragenlijst"
      },
      "USER_TYPE": {
        "DESCRIPTION": "Online of offline",
        "LABEL": "Deelname",
        "OFFLINEUSER": "Offline",
        "PLACEHOLDER": "Filteren op type deelname",
        "USER": "Online"
      },
      "VISIBILITY": {
        "DRAFT": "Ontwerp",
        "LABEL": "Zichtbaarheid",
        "PLACEHOLDER": "Filter op zichtbaarheid",
        "PLANNED": "Gepland",
        "PUBLISHED": "Gepubliceerd"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "De filters worden opgeslagen voor alle geautoriseerde beheerders en managers.",
      "NO_FILTERABLE_QUESTIONS": "Geen filters beschikbaar.",
      "SECTION_TITLE_FORM": "Informatie van het formulier",
      "SECTION_TITLE_PARTICIPANTS": "Profiel van de deelnemers",
      "TITLE": "Filteren"
    },
    "MENU": {
      "ASSIGNMENT": "Toewijzingen",
      "COMMUNICATION": "Nieuws",
      "CONSULTATION": "Consultaties",
      "FOLDER": "Dossiers",
      "GENERAL": "Algemeen",
      "MESSAGING": "Berichten",
      "NEWSLETTER": "Nieuwsbrieven",
      "PARTICIPATION": "Deelname",
      "SETTINGS": "Instellingen",
      "SETTINGS_ACCESS": "Toegang",
      "SETTINGS_COMMUNICATION": "Communicatie",
      "SETTINGS_GENERAL": "Algemeen",
      "SETTINGS_LEGAL": "Juridische teksten",
      "SETTINGS_PAGES": "Pagina's",
      "STATS": "Voorvertoning",
      "USER": "Gebruikers"
    },
    "NEWSLETTERS": "Newsletters",
    "PARTICIPATION": "Deelname",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Activeer",
        "APPLICATION_FILE_LABEL": "Een gedetailleerd sjabloon voor een aanvraagdossier importeren",
        "APPLICATION_FILE_TOOLTIP": "Om aanvullende informatie van gebruikers te vragen bij het indienen van een nieuwe bijdrage, kunt u hen een gedetailleerd sollicitatieformulier als sjabloon verstrekken.<br></br><b>Geaccepteerde formaten:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "Het indieningsformulier komt overeen met de informatie die de gebruiker moet invullen om zijn bijdrage te plaatsen.",
        "REQUIRED": "Verplicht",
        "TITLE": "Indieningsformulier"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "Nieuwsinstellingen"
        },
        "CONSULTATION": {
          "TITLE": "Consultatie-instellingen"
        },
        "FOLDER": {
          "TITLE": "Map van mappeninstellingen"
        }
      },
      "TABS": {
        "ANALYSIS": "Voeg toe aan de agenda",
        "APPEARANCE": "Algemeen",
        "DISABLED_TOOLTIP": "Vul het huidige formulier in en sla het op om het te openen",
        "IMPLEMENTATION": "Resultaten",
        "MANAGERS": "Beheerders",
        "PRESENTATION": "Presentatie",
        "PUBLIC_FILTERS": "Openbare filters",
        "QUESTIONS": "Vragen",
        "SECURITY": "Veiligheid",
        "SETTINGS": "Instellingen",
        "SUBMISSION": "Opslaan",
        "VOTE": "Stemmen"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Voeg geavanceerd zoeken toe aan uw consultatie om uw gebruikers in staat te stellen bijdragen op uw pagina te filteren.",
      "TITLE": "Openbare filters"
    },
    "SHOW": "Zie",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "Eerste pagina",
        "LAST_PAGE": "Laatste pagina",
        "NEXT_PAGE": "Volgende pagina",
        "PREVIOUS_PAGE": "Vorige pagina"
      },
      "BUTTONS": {
        "ACTIONS": "Acties",
        "CHANGE_STATUS": "Verander de status",
        "DELETE": "Verwijderen"
      },
      "PAGINATION": "{from}-{to} van {count}",
      "TITLES": {
        "ACTIONS": "Acties",
        "ASSIGNED": "Toegewezen",
        "AUTHOR": "Auteur",
        "BIRTHDATE": "Geboortedatum",
        "BUDGET": "Kostprijs",
        "COMMENTS_COUNT": "Opmerkingen",
        "COMMUNICATIONS_COUNT": "Nieuws",
        "CONSULTATION": "Raadpleging",
        "CONSULTATIONS_COUNT": "Raadplegingen",
        "CONSULTATION_TITLE": "Titel van de raadpleging",
        "CONTRIBUTION": "Bijdrage",
        "CREATED_AT": "Uitnodigingsdatum",
        "EMAIL": "E-mail",
        "FIRST_NAME": "Voornaam",
        "FOLDER": "Dossier",
        "FOLDERS_COUNT": "Dossiers",
        "HAS_ACCESS": "Toegang?",
        "ID": "ID",
        "IDEAS_COUNT": "Bijdragen",
        "LAST_NAME": "Naam",
        "LAST_VOTE_AT": "Datum stemming",
        "NEWSLETTER_CREATED_AT": "Gemaakt op",
        "NEWSLETTER_SENT_AT": "Verzonden op",
        "NEWSLETTER_SUBJECT": "Onderwerp",
        "NEWSLETTER_TITLE": "Newsletter",
        "PARTICIPATION_TYPE": "Deelname",
        "PICTURE": " ",
        "PUBLICATION_DATE": "Publicatie",
        "RECIPIENTS": "Ontvangers",
        "RESPONSE_DATE": "Datum",
        "ROLE": "Rol",
        "SENT_AT": "Verzonden op",
        "SOURCE": "Deelname",
        "STATE": "Staat",
        "STATUS": "Status",
        "SUBSCRIPTION_DATE": "Datum van inschrijving",
        "TITLE": "Titel",
        "TOPIC": "Onderwerp",
        "TYPE": "Type",
        "USER": "Gebruiker",
        "VISIBILITY": "Zichtbaarheid",
        "VOTES_AGAINST_COUNT": "Stemmen tegen",
        "VOTES_COUNT": "Stemmen tellen",
        "VOTES_FOR_COUNT": "Stemmen voor"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "DD/MM/YYYY"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {Laatste dag} one {nog {count} dag} other {nog {count} dagen}}",
    "INVALID_LABEL": "ongeldig",
    "IN_N_DAYS": "Begint over {count}",
    "LABEL": {
      "DEFAULT": "Selecteer een datum",
      "SCHEDULE_LABEL": "Publiceren voor de",
      "SCHEDULE_TITLE": "Plan de publicatie"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Inhoud van de e-mail",
        "PLACEHOLDER": "Hallo, ..."
      },
      "DELETED_USER_WARNING": "Deze gebruiker heeft verzocht om zijn/haar account te verwijderen. U kunt daarom geen contact met hem/haar opnemen.",
      "SEND": "Verstuur",
      "SUBJECT": {
        "LABEL": "Onderwerp van de e-mail",
        "PLACEHOLDER": "Verzoek om aanvullende informatie over ..."
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {Geen Privé-aantekeningen} one {{count} Privé-aantekening} other {{count} Privé-aantekeningen}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Schrijf een privé-aantekening",
        "PUBLIC": "Jouw reactie"
      },
      "INFO": "Wees voorzichtig om geen opmerkingen te schrijven die gegevens bevatten die als gevoelig worden beschouwd.",
      "INFO_TOOLTIP": "Raciale of etnische afkomst, politieke, filosofische of religieuze meningen, vakbondslidmaatschap, gezondheidsgegevens, seksuele voorkeur, strafregister,…",
      "NO_COMMENTS": "Schrijf als eerste een privé-aantekening"
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# bijdragen vergelijkbaar met deze samengevoegd} one {{count} vergelijkbare bijdrage samengevoegd met deze} other {{count} vergelijkbare bijdragen samengevoegd met deze}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Terug naar de startpagina",
    "CTA_NO_SPACE": "Ruimte vinden voor participatie",
    "FORMER_CLIENT_TOAST": "De ruimte die je probeert te bezoeken bestaat niet of niet meer.",
    "NOT_FOUND": {
      "DESCRIPTION": "Het lijkt erop dat we je op het verkeerde pad hebben gebracht. Zullen we opnieuw beginnen?",
      "TITLE": "Sorry, we konden de pagina die u zoekt niet vinden."
    },
    "OFFLINE": {
      "DESCRIPTION": "Het lijkt erop dat je offline bent. Laten we even vernieuwen?",
      "TITLE": "Sorry, we konden de pagina die u zoekt niet vinden."
    },
    "RELOAD": "Herladen",
    "SERVER_ERROR": {
      "DESCRIPTION": "Wees gerust, onze ontwikkelaars doen er alles aan om dit te verhelpen. We zouden snel terug moeten zijn.",
      "TITLE": "Oeps, er is een onverwachte fout opgetreden."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Toegankelijkheid",
    "ETHICAL_POLICY": "Ethische charter",
    "HELP": "Hulp",
    "LEGAL_NOTICE": "Juridische vermeldingen",
    "PRIVACY_POLICY": "Privacybeleid",
    "TERMS_OF_USE": "Gebruiksvoorwaarden"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "U moet de velden correct invullen.",
      "REQUIRED": "U moet dit veld invullen."
    },
    "SELECT_EMPTY_LABEL": "Niet gespecificeerd",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Verwijdering succesvol uitgevoerd",
      "UPDATED_SUCCESSFULLY": "Uw wijzigingen zijn opgeslagen."
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "Beantwoord op <b>{date}</b> om <b>{time}</b>",
    "SHOW_RESPONSE": "Bekijk mijn antwoord",
    "SUBMISSION_NOT_ONGOING": "De raadpleging is gesloten, u kunt niet langer antwoorden of uw antwoord wijzigen.",
    "UPDATE_RESPONSE": "Aanpassen van mijn antwoord"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "Weet u zeker dat u dit item wilt verwijderen?",
    "CTA": "Ja, verwijderen",
    "TITLE": "Verwijderen"
  },
  "HOME": {
    "PAGE_TITLE": "Welkom zeker Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Voer de naam van de ruimte",
    "SUBTITLE": "Zoek een ruimte om deel te nemen"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Afbeelding laden mislukt",
    "LOADING": "Afbeelding laden"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "Om meerdere bijdragen die buiten het platform zijn ontvangen toe te voegen, {link} zonder het formaat te wijzigen.<br></br>Als u bepaalde informatie niet hebt verzameld, verwijder dan geen kolommen en laat ze leeg.<br></br>Als uw bijdragen in meerdere talen zijn, vertaal ze dan allemaal naar {defaultLang} voordat u ze importeert.",
        "LINK": "vul het model in",
        "TITLE": "Bijdragen importeren"
      },
      "STATUS": {
        "DESCRIPTION": "De status van de bijdragen aangeven tijdens het importeren.",
        "TITLE": "Status kiezen"
      }
    },
    "ERROR": {
      "DESCRIPTION": "Het is niet mogelijk om uw bestand te importeren. Controleer of uw bestand voldoet aan het model.",
      "EXPLANATION": "Controleer of er geen kolommen zijn verwijderd en of de antwoorden aan het gevraagde formaat voldoen.",
      "ROWS_MULTIPLE": "Het is niet mogelijk om uw bestand te importeren. Er zijn fouten geïdentificeerd in de regels {rows}.",
      "ROWS_SINGLE": "Het is niet mogelijk uw bestand te importeren. Er is een fout geïdentificeerd op regel {rows}.",
      "ROWS_WITH_MORE": "Kan uw bestand niet importeren. Er zijn fouten geïdentificeerd op de regels {rows} en {moreCount} andere."
    },
    "FORM": {
      "CTA": "Importeur",
      "UPLOAD_DATE": "{size} - Bijgewerkt op {date}",
      "UPLOAD_TITLE": "Sleep het bestand of klik"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "Om meerdere antwoorden ontvangen buiten het platform toe te voegen, {link} zonder het formaat te wijzigen.<br></br>Als u bepaalde informatie niet hebt verzameld, verwijder dan alstublieft de kolommen niet en laat ze leeg.<br></br>Als uw antwoorden in meerdere talen zijn, vertaal ze dan alstublieft allemaal naar {defaultLang} voordat u ze importeert.",
        "LINK": "vul het model in",
        "TITLE": "Antwoorden importeren"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Controleer of de informatie in uw import overeenkomt met de kolommen van het model.<br></br>Als de informatie niet overeenkomt, moet u uw bestand aanpassen en vervolgens uw bijgewerkte bestand importeren.",
      "TITLE": "Vérifieer de gegevens"
    },
    "PROGRESS": "Importeren bezig…",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "Om stemmen die buiten het platform zijn ontvangen toe te voegen, {link} zonder het formaat te wijzigen. Als u bepaalde informatie niet heeft verzameld, gelieve de kolommen <b>niet te verwijderen</b> en leeg te laten.",
        "LINK": "vul het model in",
        "TITLE": "Het importeren van stemmen"
      }
    }
  },
  "JOIN": "Ontmoeten",
  "JOINED_SPACE": "Welkom in {space}!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "Wij zullen u op de hoogte houden als er in de toekomst relevante raadplegingen voor jou worden geplaatst. U kunt ook andere bestaande ruimtes vinden door de onderstaande zoekfunctie te gebruiken en in te loggen met uw huidige account.",
      "CONTENT_NOT_FOUND": "Om opnieuw deel te nemen aan een raadpleging, moet u opnieuw een account aanmaken.",
      "TITLE": "Dank u voor uw keuze om uw account actief te houden",
      "TITLE_NOT_FOUND": "Uw account bestaat niet meer of is al geanonimiseerd!"
    }
  },
  "LOADING_MORE": "Laden…",
  "LOAD_MORE": "Meer laden",
  "MENU_ITEMS": {
    "DESCRIPTION": "Pas aan welke tabbladen worden weergegeven in uw navigatiebalk.",
    "FORM": {
      "ADD_ITEM": "Toevoegen aan tabblad",
      "ADD_SUBITEM": "Toevoegen van een subtabblad",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Label",
          "PLACEHOLDER": "Geef het label van uw tabblad op"
        },
        "LINK": {
          "LABEL": "Externe link",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Standaardpagina",
          "PLACEHOLDER": "Selecteer een pagina"
        },
        "POST": {
          "LABEL": "Inhoud",
          "NO_OPTIONS": "Geen inhoud gevonden",
          "PLACEHOLDER": "Voeg toe aan de agenda"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "Nieuws",
          "CONSULTATION": "Consultaties",
          "FOLDER": "Map",
          "LABEL": "Soort inhoud",
          "PLACEHOLDER": "Geselecteer een inhoudstype"
        },
        "TYPE": {
          "LABEL": "Typen",
          "PLACEHOLDER": "Selecteer een type"
        }
      }
    },
    "GROUP": "Uitklapmenu",
    "LINK": "Lid worden bij het webevenement: {url}",
    "NEW_GROUP": "NIEUW UITKLAPMENU",
    "NEW_ITEM": "NIEUW ITEM",
    "PAGE": "Standaardpagina",
    "PAGE_ABOUT": "Over",
    "PAGE_CONSULTATIONS": "Raadplegingen",
    "PAGE_NEWS": "Nieuws",
    "PAGE_SEARCH": "Zoeken op",
    "POST": "Inhoud",
    "TITLE": "Uw navigatiebalk"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Een discrepantie melden"
    },
    "DEMAND": {
      "REPORT_CTA": "Stuur een bericht"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "Fluicity Engage is een oplossing voor burgerbetrokkenheid, die collectieve besluitvorming over kwesties van algemeen belang mogelijk maakt.",
    "PAGES_TITLES": {
      "ABOUT": "Over | {spaceName}",
      "CONSULTATIONS": "Raadplegingen | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "Mijn berichten en anomalieën | {spaceName}",
        "PROPOSALS": "Mijn bijdragen | {spaceName}"
      },
      "DASHBOARD": "Dashboard | {spaceName}",
      "LEGAL_NOTICE": "Wettelijke vermeldingen | {spaceName}",
      "NEWS": "Nieuws | {spaceName}",
      "PRIVACY_POLICY": "Privacybeleid | {spaceName}",
      "SEARCH": "Zoeken op | {spaceName}",
      "SETTINGS": "Mijn rekening | {spaceName}",
      "TERMS_OF_USE": "Gebruiksvoorwaarden | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName}: ontdek dit artikel over Fluicity Engage!",
      "EVENT": "{cityName}: neem deel aan dit evenement!",
      "FOLDER": "{title} {url}",
      "IDEA": "Steun deze bijdrage: {title} {url}"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{title}",
      "IDEA": "Ondersteun deze bijdrage: {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "U kunt uw bijdrage wijzigen of deze zoals deze is indienen. De diensten zullen beoordelen of uw bijdrage gepubliceerd kan worden of niet.",
      "REASON": "Reden:",
      "SUBMIT": "Verzenden",
      "TITLE": "Uw bijdrage is als verdacht aangemerkt."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "DD-MM-YYYY",
      "PLACEHOLDER": "DD-MM-YYYY"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Dashboard",
    "MY_ACCOUNT": "Mijn rekening",
    "MY_PROFILE": "Mijn profiel"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "Deze newsletter is al verzonden",
    "CREATED_AT": "Gemaakt op <b>{date}</b> om <b>{time}</b>",
    "DRAFT": "voorlopige versie",
    "FORM": {
      "CLEAR_SCHEDULING": "Annulatie van de planning.",
      "CONTENT": {
        "LABEL": "Inhoud",
        "PLACEHOLDER": "Inhoud van de e-mail"
      },
      "RECIPIENTS": {
        "ALL": "Alle gebruikers",
        "LABEL": "Ontvangers",
        "PLACEHOLDER": "Selecteer ontvangers"
      },
      "SAVE_SUCCESS": "Uw newsletter is succesvol geregistreerd",
      "SCHEDULE": "Plannen",
      "SCHEDULED_AT": "Bezorgdatum",
      "SEND": "Verzenden",
      "SEND_SUCCESS": "Uw newsletter is succesvol verzonden",
      "SEND_TEST": "Test verzenden",
      "SUBJECT": {
        "LABEL": "Subject",
        "PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers wekt."
      },
      "TEST_EMAIL": {
        "LABEL": "Test e-mailadressen",
        "PLACEHOLDER": "Voer de test-e-mailadressen in (gescheiden door komma's)"
      },
      "TEST_SUCCESS": "Uw testnewsletter is succesvol verzonden"
    },
    "IMMEDIATELY": "Onmiddellijk",
    "NEW_NEWSLETTER": "Creëer een newsletter",
    "SCHEDULED": "gepland",
    "SENT": "verzonden",
    "SENT_AT": "Verzonden op <b>{date}</b> om <b>{time}</b>",
    "UPDATE_NEWSLETTER": "Bewerk newsletter",
    "USERS_FILTER_COUNT": "{count, plural, =0 {Er is geen ontvanger gevonden voor deze selectie} one {Uw nieuwsbrief wordt naar 1 persoon verzonden} other {Uw nieuwsbrief wordt naar {count} personen verzonden}}"
  },
  "NEXT": "Volgende",
  "NONE": "Geen",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Consultaties :<br />• Nieuwe bijdragen<br />• Nieuwe antwoorden op enquêtes<br />• Wanneer een burger reageert op een van mijn opmerkingen<br />• Wanneer een fase of consultatie binnenkort eindigt<br /><br />Berichten :<br />• Nieuwe berichten<br />• Nieuwe anomalieën<br />• Wanneer een burger reageert op een van mijn opmerkingen",
        "SUBTITLE": " (daily)",
        "TITLE": "Latest activities"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Wijziging van een bijdrage door de auteur<br />• Moderatie van inhoud door het Fluicity Engage-team",
        "TITLE": "Andere"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• Nieuw overleg<br />• Start van een ideeen-, stem- of resultatenfase",
        "TITLE": "Consultaties"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Reactie of stem op mijn bijdrage<br />• Reactie op mijn opmerking<br />• Verandering van status van mijn bijdrage",
        "SUBTITLE": " (dagelijks)",
        "TITLE": "Uw laatste activiteiten"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Nieuwsbrieven over de activiteit van het platform",
        "TITLE": "Newsletters"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Verwijderen van een bijdrage die je hebt becommentarieerd<br />• Moderatie van een inhoud die je hebt becommentarieerd",
        "TITLE": "Andere"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• Nieuwe artikelen<br />• Nieuwe evenementen<br />• Bijdragen in de schijnwerpers",
        "SUBTITLE": " (wekelijks)",
        "TITLE": "Momenteel op de ruimte"
      }
    },
    "INFO_BOX_TEXT": "Selecteer hier de e-mailmeldingen die u van het platform wilt ontvangen."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "Waarom?",
    "EXTREMELY_LIKELY": "Zeer waarschijnlijk",
    "NOT_LIKELY": "Niet waarschijnlijk",
    "TITLE": "Vertel ons wat u denkt over Fluicity Engage",
    "VALUE_QUESTION": "Hoe waarschijnlijk is het dat u Fluicity Engage aanbeveelt aan een collega?"
  },
  "OFFLINE": "Offline",
  "ONLINE": "Online",
  "OR": "op",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "Geen bijdrage kan worden geselecteerd",
    "TITLE": "Deze bijdrage is samengevoegd met de volgende vergelijkbare bijdrage"
  },
  "PAGE_OF": "Pagina {current} van {total}",
  "PASSWORD_RESET": {
    "ACTION": "update",
    "ARIA_LABEL": "Schakel wachtwoord zichtbaarheid",
    "PAGE_TITLE": "Creëer een nieuw wachtwoord",
    "TITLE": "Creëer een nieuw wachtwoord",
    "TOAST": "Het nieuwe wachtwoord is opgeslagen."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Terug naar de startpagina",
    "LINK_SENT": "Als er een account is gekoppeld aan het e-mailadres <strong>{email}</strong>, ontvangt u een reset-link. <br></br><br></br>Als u geen e-mail ziet, controleer dan uw ongewenste e-mail.",
    "PAGE_TITLE": "Reset uw wachtwoord",
    "RESET": "Opnieuw instellen",
    "SUB_TITLE": "Wachtwoord vergeten? Het gebeurt bij iedereen! We sturen je een e-mail met een link om het te resetten.",
    "TITLE": "Reset uw wachtwoord"
  },
  "PICTURE_PICKER": {
    "COVER": "Kies een afbeelding om uw publicatie te illustreren"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "Aangemaakt {date}",
      "MODAL": {
        "AFTER": "Na wijziging",
        "BEFORE": "Vóór wijziging",
        "TITLE": "Geschiedenis"
      },
      "NO_AUDITS": "Deze bijdrage is nog niet bijgewerkt.",
      "UPDATE": "Bijgewerkt {date}"
    },
    "AUTHOR": "Schrijver",
    "BUDGET": {
      "ALERT": "U moet de kosten van de bijdrage opgeven voordat u deze als \"Vastgehouden\" kunt instellen.",
      "BUDGET_VALUE": "Deze bijdrage kost <b>{budget}</b>",
      "MODAL_LABEL": "Kost van de bijdrage",
      "MODAL_TITLE": "Vul de kosten in",
      "NOT_ENOUGH_BUDGET": "Het resterende budget is ontoereikend.",
      "NOT_SELECTED": "Deze bijdrage is niet geselecteerd voor de stemfase.",
      "REMAINING_BUDGET": "Je hebt nog <strong>{remaining}</strong> te besteden"
    },
    "CARD": {
      "CONTRIBUTE": "Bijdragen",
      "PARTICIPATE": "Deelnemen",
      "READ_MORE": "Lees verder",
      "VOTE": "Stemmen"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {{progress} stemmen} one {{progress} stem} other {{progress} stemmen}}",
        "TOOLTIP_2": "{total, plural, =0 {op {total} bijdrage} one {op {total} bijdrage} other {op {total} bijdragen} }"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Bijdrage",
          "TEXT_1": "Of als u verder wilt gaan",
          "TEXT_2": "doe je een bijdrage?"
        },
        "VOTE_CARD": {
          "CTA": "Stem",
          "TEXT_1": "U heeft al enkele bijdragen bekeken {emoji}",
          "TEXT_2": "wil je doorgaan?",
          "TEXT_3": "of ga naar de volledige lijst"
        }
      }
    },
    "CLONE": {
      "ACTION": "Dupliceren",
      "CANCEL": "Nee",
      "CONFIRM": "Ja, dupliceren",
      "CONTENT_CLONED": "Dit materiaal is succesvol gedupliceerd.",
      "DESCRIPTION": "Wilt u deze inhoud echt dupliceren?",
      "SUCCESS": "Dit bericht is verwijderd."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Opmerkingen} one {Commentaar} other {Opmerkingen}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "Wees de eerste om deel te nemen!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {{count} raadplegingen} one {{count} raadpleging} other {{count} raadplegingen}}",
      "ENDED_AT": "Raadpleging eindigde op de {date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {Geen bijdrage} one {# bijdrage} other {# bijdragen} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {Geen gelokaliseerde bijdragen} one {1 gelokaliseerde bijdrage} other {# gelokaliseerde bijdragen}}"
      },
      "MAP_TOOLTIP": "De niet-geolokaliseerde bijdragen worden niet weergegeven op de kaart. Een bijdrage kan meerdere locaties hebben.",
      "NEWS_COUNT": "{count, plural, =0 {nieuws} one {{count} actualiteit} other {{count} nieuws}}",
      "ONGOING_TEXT": "Kom hierheen om mee te doen.",
      "PARTICIPATE_OFF": "Kom binnenkort hier langs om bij te dragen aan de bijdragen!",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Ontdek de resultaten",
        "PARTICIPATE": "Neem deel aan de raadpleging"
      },
      "SEE_OWN_VOTES": "Zie alleen mijn stemmen",
      "STARTS_AT": "Overleg begint op de {datum}",
      "STEP_ENDED_AT": "De \"{step}\" fase eindigde op {date}",
      "STEP_STARTS_AT": "Afspraak op {date} om de fase \"{step}\" te ontdekken"
    },
    "CONTENT_DELETED_SUCCESSFULLY": "de inhoud is verwijderd",
    "CREATE_MENU": {
      "ACTIONS": "Acties",
      "ADDED_TO_FOLDER_TOAST": "Inhoud toegevoegd aan map.",
      "ADD_TO_FOLDER": "Toevoegen aan een dossier",
      "ARTICLE": {
        "DESCRIPTION": "Een nieuws of initiatief presenteren"
      },
      "ASSIGN": "Toewijzen",
      "BUTTON": "Creëren",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Implementeren van co-geconstrueerde bijdragen met gebruikers"
      },
      "CONTACT_AUTHOR": "Neem contact op met de auteur",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Maak een nieuws",
        "CONSULTATION": "Maak een consultatie"
      },
      "EDIT": "Bewerk",
      "EVENT": {
        "DESCRIPTION": "Nodig uit om deel te nemen aan een vergadering"
      },
      "FOLDER": {
        "DESCRIPTION": "Maak een pagina om inhoud te centraliseren"
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Verzamel bijdragen over uw strategische vraagstukken"
      },
      "MERGE": "Samenvoegen van de bijdrage",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Toewijzen van een budget aan co-geconstrueerde bijdragen met gebruikers"
      },
      "PIN": "Voorzien zijn van",
      "REMOVED_FROM_FOLDER_TOAST": "Inhoud verwijderd uit de map.",
      "REPORT": "Verslag doen van",
      "STEPS_COUNT": "{count, plural, one {# stap} other {# stappen}}",
      "STUDY": {
        "DESCRIPTION": "Een enquête die buiten het platform is gemaakt integreren",
        "TITLE": "Vragenlijst - Integratie"
      },
      "SURVEY": {
        "DESCRIPTION": "Ondervraag gebruikers over een specifiek onderwerp en verzamel gedetailleerde informatie"
      },
      "UNPIN": "Onvolledig",
      "UNPUBLISH": "Publicatie ongedaan maken",
      "UPDATE_BUDGET": "Vul de kosten in",
      "UPDATE_STATUS": "Verander de status",
      "VIEW": "Zie de publicatie",
      "VIEW_IN_DASHBOARD": "Dashboard",
      "VIEW_POST": "Zie de publicatie"
    },
    "DELETE": {
      "ACTION": "Verwijderen",
      "CANCEL": "Nee",
      "CONFIRM": "Ja, verwijderen",
      "CONTENT_DELETED": "Deze inhoud is verwijderd.",
      "DESCRIPTION": "Weet je zeker dat je deze inhoud wilt verwijderen?",
      "PLACEHOLDER": "Verklaar waarom deze post wordt verwijderd",
      "REASON": "Commentaar",
      "SELECT_REASON": "Geef aan waarom je deze post verwijdert.",
      "SUCCESS": "De inhoud werd verwijderd"
    },
    "DETAILS": {
      "AUTHORED_BY": "Dragt bij {name}",
      "DESCRIPTION_TITLE": "Beschrijving",
      "EVENT": {
        "ACCESS_THE_EVENT": "Toegang tot het evenement",
        "EVENT_URL": "Visioconferentie",
        "STATE": {
          "FUTURE": "Het evenement begint op <b>{date}</b> om <b>{time}</b>.",
          "ONGOING": "Doorlopend evenement",
          "PAST": "Het evenement is afgelopen"
        }
      },
      "MORE_TAGS": "{count, plural, one {en een ander thema} other {en {count} andere thema's}}",
      "STUDY": {
        "JOIN_BUTTON": "Ontmoeten",
        "JOIN_DESCRIPTION": "Log in of registreer je om toegang te krijgen tot de enquête!",
        "PARTICIPATE": "Deelnemen",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "Het onderzoek begint op {date}.",
          "ENDED": "Het onderzoek werd afgerond op {date}.",
          "ONGOING_ANSWERED": "Bedankt voor uw deelname, er is rekening mee gehouden."
        },
        "SEE_RESULTS": "zie de resultaten"
      },
      "UPDATE_MY_IDEA": "Bewerk"
    },
    "EXPORT": {
      "BUTTON": "Exporteren",
      "IDEAS": "Alle bijdragen",
      "MESSAGES": "Alle berichten"
    },
    "FILTER_BY_IS_PINNED": "Vastgespeld",
    "FILTER_BY_PUBLISHED": "Gepubliceerd",
    "FILTER_BY_STATUS": "Staat",
    "FILTER_BY_TAGS": "Onderwerp",
    "FILTER_BY_TYPE": "Type inhoud",
    "FILTER_IS_PINNED_TRUE": "Ja",
    "FILTER_PUBLISHED_FALSE": "Niet gepubliceerd",
    "FILTER_PUBLISHED_TRUE": "Gepubliceerd",
    "FILTER_STATUS_ANSWERED": "Niet behouden",
    "FILTER_STATUS_DOING": "Analyse in uitvoering",
    "FILTER_STATUS_DONE": "Echt gemaakt",
    "FILTER_STATUS_IN_PROGRESS": "Lopende uitvoering",
    "FILTER_STATUS_SELECTED": "Het achterhouden van",
    "FILTER_STATUS_TODO": "Ingediend",
    "FILTER_STATUS_VALIDATED": "Winnaar",
    "FILTER_TYPE_ANOMALY": "Afwijking",
    "FILTER_TYPE_ARTICLE": "Artikel",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Overleg",
    "FILTER_TYPE_DEMAND": "Bericht",
    "FILTER_TYPE_EVENT": "Evenement",
    "FILTER_TYPE_FOLDER": "Dossier",
    "FILTER_TYPE_IDEA": "Bijdrage",
    "FILTER_TYPE_IDEAS_REQUEST": "Oproepen tot bijdragen",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Participatief budget",
    "FILTER_TYPE_STUDY": "Vragenlijst",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Open voor spontane bijdragen"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Plaats",
        "PLACEHOLDER": "Een plaats toevoegen"
      },
      "CATEGORIES": {
        "LABEL": "Onderwerpen",
        "PLACEHOLDER": "Selecteer de onderwerpen van de raadpleging",
        "SELECT_ALL": "Kies alle"
      },
      "CATEGORY": {
        "LABEL": "Onderwerp",
        "PLACEHOLDER": "Kies onderwerp"
      },
      "CONTENT": "Beschrijving",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Voeg een bestand/afbeelding toe",
          "ADD_PICTURE": "Voeg een foto toe",
          "DELETE_PICTURE": "Verwijderen"
        },
        "ERRORS": {
          "FILE_SIZE": "De bestandsgrootte mag niet groter zijn dan {fileSize}MB.",
          "FILE_TYPE": "De afbeeldingen moeten in het {fileTypes} formaat zijn."
        },
        "TOOLTIP": "<b>Aanbevolen grootte:</b> {width} (breedte) bij {height} pixels (hoogte) <br></br> <b>Bestandstypen:</b> .jpg, .jpeg, .png"
      },
      "PIN": "Deze inhoud is uitgelicht.",
      "TITLE": "Titel",
      "UNPIN": "Deze inhoud wordt niet meer weergegeven."
    },
    "HOW_IT_WORKS": {
      "TITLE": "Hoe werkt het?"
    },
    "INDICATORS": {
      "ATTENDEES": "Deelnemers",
      "COMMENTS": "Opmerkingen",
      "COMMUNICATIONS": "Nieuws",
      "CONSULTATIONS": "Raadplegingen",
      "IDEAS": "Bijdragen",
      "VOTES": "Stemmen"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Ga door met het gesprek",
      "GIVE_YOUR_OPINION": "Geef uw mening"
    },
    "PREVIEW": "Bekijk op de website",
    "PUBLIC_STUDY": "Openbare studie",
    "PUBLISHED": "Gepubliceerd",
    "PUBLISHED_AT": "Gepubliceerd op {date}",
    "PUBLISH_CANCELED": "De publicatie van deze inhoud is geannuleerd",
    "PUBLISH_EDIT": "Verander de planning",
    "PUBLISH_NOW": "Publiceer nu",
    "PUBLISH_NOW_TOASTER": "Uw inhoud is nu zichtbaar voor gebruikers",
    "PUBLISH_SCHEDULED": "Plan de publicatie",
    "REPORT": {
      "ACTION": "Misbruik melden",
      "CODE_OF_ETHICS": "Gedragscode",
      "CONFIRM": "Versturen",
      "EMPTY_ERROR": "U moet de velden correct invullen.",
      "FLUICITY_TERMS_PART_A": "Lees meer over de",
      "FLUICITY_TERMS_PART_B": "en het",
      "FLUICITY_TERMS_PART_C": "van Fluicity Engage.",
      "PLACEHOLDER": "Voeg een opmerking toe om uw rapport te detailleren.",
      "SELECT_REASON": "Geef aan waarom u deze inhoud rapporteert:",
      "SUCCESS": "Bedankt voor deze melding. Hiermee kunnen we inhoud van kwaliteit garanderen op Fluicity Engage.",
      "TERMS_OF_USE": "Gebruiksvoorwaarden"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Antwoorden} one {Antwoord} other {Antwoorden}}",
    "SAVE": "Registreer",
    "SAVE_THE_DRAFT": "Bewaar als concept",
    "SCHEDULE": "tijdschema",
    "SCHEDULED": "Gepland",
    "SCHEDULED_AT": "Gepland op {date}",
    "SCHEDULED_AT_TOASTER": "De publicatie van deze inhoud is gepland voor {date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "Zie de overleg",
      "FOLDER": "Zie het dossier",
      "IDEA": "Zie de bijdrage",
      "IDEAS_REQUEST": "Bekijk de oproep voor bijdragen",
      "PARTICIPATORY_BUDGET": "Zie de participatief budget"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "Van <strong>{startAtDate} op {startAtHour}</strong> tot <strong>{endAtDate} op {endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Zwart en wit",
        "DOWNLOAD": "Download",
        "GENERATE": "Genereer QR-code",
        "TITLE": "QR-code"
      },
      "SHARE_IT": "Deel het"
    },
    "SORT": {
      "BUTTON": "Sorteren",
      "POPULAR": "Populair",
      "RECENT": "Recent"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Samenvatting van de deelname"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {De status wijzigen} one {De status wijzigen} other {De status wijzigen: {count} geselecteerde bijdragen}}",
      "MODAL": {
        "TITLE": "Voortgang van een bijdrage"
      },
      "ORIGINAL_POST": {
        "LABEL": "Titel van de oorspronkelijke bijdrage die behouden blijft",
        "TITLE": "Geef de titel op van de oorspronkelijke bijdrage waaraan deze bijdrage moet worden gekoppeld:"
      },
      "POPOVER": {
        "BUTTON": "Om er meer over te weten"
      },
      "SUBMIT": "Bijwerken",
      "TITLE": "Staat",
      "UPDATED_SUCCESSFULLY": "Staat is succesvol bijgewerkt."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Beschikbaar",
        "COMING": "Aankomende",
        "ENDED": "Voltooid",
        "ENDLESS": "Doorlopend",
        "ONGOING": "Bezig"
      },
      "TABS": {
        "LABEL": "Selectietabbladen voor de publicatiefases"
      }
    },
    "SUMMARY": {
      "TITLE": "Samenvatting van de bijdrage",
      "TOOLTIP": "Dit overzicht is gegenereerd met behulp van kunstmatige intelligentie om het lezen van de bijdrage te vergemakkelijken."
    },
    "TAGS": {
      "PERIOD": "Van <strong>{startAtDate} op {startAtHour}</strong> tot <strong>{endAtDate} op {endAtHour}</strong>",
      "PERIOD_SAME_DAY": "De <strong>{startAtDate}</strong> van <strong>{startAtHour}</strong> tot <strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "Van <strong>{startAtDate}</strong> tot <strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Afwijking",
      "ARTICLE": "Artikel",
      "COLLABORATIVE_DECISION": "Overleg",
      "DEMAND": "Bericht",
      "EVENT": "Evenement",
      "FOLDER": "Dossier",
      "IDEA": "Bijdrage",
      "IDEAS_REQUEST": "Oproepen tot bijdragen",
      "PARTICIPATORY_BUDGET": "Participatief budget",
      "STUDY": "Vragenlijst",
      "SURVEY": "Vragenlijst"
    },
    "UPDATED": "De inhoud is succesvol bijgewerkt"
  },
  "POST_FORM": {
    "ACTION_SAVE": "Registreer",
    "ADMIN_UPDATE_ALERT": "Wanneer u een bijdrage wijzigt, sturen we automatisch een melding per e-mail naar de auteur. Om ervoor te zorgen dat de auteur akkoord gaat met uw wijziging, raden we u aan om rechtstreeks contact met hem op te nemen voordat u wijzigingen aanbrengt.",
    "APPLICATION_FILE": "Importeer uw gedetailleerde aanvraagdossier",
    "APPLICATION_FILE_BUTTON": "Map toevoegen",
    "APPLICATION_FILE_TOOLTIP": "Om uw bijdrage in te dienen, moet u verplicht een gedetailleerd sollicitatiebestand verstrekken. Vul hiervoor het meegeleverde sjabloon in en upload het hieronder.<br></br><br></br>In tegenstelling tot de informatie die wordt verstrekt in de rest van het formulier (titel, beschrijving, thema, enz.) die openbaar zullen zijn, zal de inhoud van het bestand alleen toegankelijk zijn voor de beheerders van het platform.<br></br><br></br><b>Geaccepteerde formaten:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Deel aanvullende documenten zoals afbeeldingen of een video met uw nieuws.",
        "CONSULTATION": "Deel aanvullende documenten zoals uw reglement, afbeeldingen of een video tijdens uw consultatie.",
        "FOLDER": "Deel aanvullende documenten zoals afbeeldingen of een video in uw dossier."
      },
      "TITLE": "Bijlagen"
    },
    "ATTACHMENTS_FILES": "Bestanden",
    "ATTACHMENTS_IMAGES": "Afbeeldingen",
    "ATTACHMENTS_TITLE": "Documenten",
    "AUTHORED_BY": "Wie is de auteur?",
    "AUTHORED_BY_A_THIRD_PARTY": "Een derde persoon",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "Een persoon buiten het platform",
    "AUTHORED_BY_CUSTOM": "Gepersonaliseerd",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Vereniging, burgergroep, vergadering…",
    "AUTHORED_BY_FIRST_NAME": "Voornaam van de auteur",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Voorbeeld: Jan",
    "AUTHORED_BY_LAST_NAME": "Naam van de auteur",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Voorbeeld: Jansen",
    "AUTHORED_BY_MYSELF": "Ik",
    "AUTHORED_BY_MY_SPACE": "Mijn organisatie",
    "BUDGET": "Geschat budget",
    "BUDGET_PLACEHOLDER": "Geef de begroting aan",
    "CHOOSE_A_FOLDER": "Kies een dossier",
    "CONTENT": "Beschrijving",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Soort bijdrage",
      "CUSTOM_PLACEHOLDER": "Geef aan welk soort bijdragen u wilt verzamelen.",
      "DESCRIPTION": "Aanpassen van het label van de knop (CTA) om bijdragen in te dienen.",
      "OPTIONS": {
        "CONTRIBUTION": "Bijdrage",
        "OTHER": "Autre",
        "PROPOSAL": "Voorstel",
        "QUESTION": "Vraag",
        "REPORT": "Melding"
      },
      "PREVIEW": "Voorbeeld:",
      "TITLE": "Soort bijdrage"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "Feedback aanmoedigen (voor of tegen stemmen)",
          "NAME": "Carrousel"
        },
        "LIST": {
          "DESCRIPTION": "Voor een compacte weergave van alle bijdragen",
          "NAME": "Lijst"
        },
        "MAP": {
          "DESCRIPTION": "Voor een geografische visualisatie van de bijdragen",
          "NAME": "Kaart"
        }
      },
      "SUBTITLE": "Pas de pagina van uw consultatie aan door de standaardweergave van bijdragen te kiezen. in ieder geval zullen gebruikers een andere weergave kunnen kiezen.",
      "TITLE": "Weergave van bijdragen"
    },
    "DESCRIPTION": "Beschrijving",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "Deze sectie stelt u in staat om aan gebruikers de context en de inzet van uw nieuws uit te leggen.",
        "CONSULTATION": "Deze sectie stelt u in staat om gebruikers de context en de uitdagingen van uw consultatie uit te leggen.",
        "FOLDER": "Deze sectie stelt u in staat om aan gebruikers de context en de belangen van uw zaak uit te leggen."
      },
      "TITLE": "Omschrijving"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Toon de bijdrageafbeeldingen in de lijst",
        "TITLE": "Afbeelding"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Reacties onder uw enquête inschakelen"
      },
      "GEOJSON": {
        "DESCRIPTION": "Pas de kaart aan met geografische gebieden en interessante plaatsen op {link} en plak vervolgens de onderstaande code.",
        "TITLE": "Personaliseer de kaart"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "De wijziging aanbrengen",
        "COMMUNICATION": "Het nieuws bewerken.",
        "CONSULTATION": "Aanpassen van de afspraak",
        "DEMAND": "Bericht wijzigen",
        "FOLDER": "Bewerk de map",
        "IDEA": "De bijdrage wijzigen"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "Om een gebruiker toegang te geven, moet hij een <i>Manager</i> van de ruimte zijn. Alleen een <i>Administrator</i> kan deze rol toewijzen.",
      "SUBTITLE": "De lijst met gebruikers die toegang hebben om die raadpleging te beheren.",
      "TITLE": "Beheerders"
    },
    "END_AT": "Einddatum en tijd",
    "ERRORS": {
      "FILL_FIELDS": "U moet de velden correct invullen.",
      "LOCATION_NOT_IN_THE_LIST": "U moet een adres selecteren uit de lijst."
    },
    "EVENT_URL_LABEL": "Visioconferentie",
    "EVENT_URL_PLACEHOLDER": "Voeg de URL toe van een Zoom, Jitsi, Teams, Meet, etc",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Toegestane antwoord(en)",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "De door de gebruiker ingevoerde datum valideren met een referentiedatum.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Selecteer een operator",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Selecteer elk mogelijk antwoord.",
      "ACCEPTED_ANSWERS_SUMMARY": "Toegestane antwoorden",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Elke toegestane reactie scheiden met een regeleinde.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Antwoord 1  \nAntwoord 2  \nAntwoord 3  \nAntwoord 4",
      "ADD_DESCRIPTION": "Toevoegen beschrijving",
      "ADD_QUESTION": "Toevoegen van een vraag",
      "ADD_SECTION": "Sectie toevoegen",
      "CONFIDENTIAL": "Vertrouwelijk",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Uw antwoord zal alleen zichtbaar zijn voor de platformbeheerders.",
      "CONFIDENTIAL_QUESTION": "Vertrouwelijke vraag",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "Het antwoord zal alleen zichtbaar zijn voor beheerders en managers met de juiste rechten.",
      "DATE_OPERATOR": {
        "EQ": "is",
        "GT": "is groter dan",
        "GTE": "is gelijk aan of groter dan",
        "LT": "is kleiner dan",
        "LTE": "is kleiner dan of gelijk aan",
        "NOT_EQ": "is niet"
      },
      "DEFAULT_FIELD_INFO": "Standaard",
      "DESCRIPTION_LABEL": "Beschrijving",
      "DESCRIPTION_PLACEHOLDER": "Voorbeeld: Deze vraag zal ons helpen u beter te leren kennen.",
      "DROPDOWN_QUESTION": "Liste met keuzelijst",
      "DROPDOWN_QUESTION_DESCRIPTION": "De opties worden weergegeven in een vervolgkeuzelijst",
      "MAXLENGTH": "Beperk het aantal tekens",
      "MAXLENGTH_DESCRIPTION": "Het maximale aantal toegestane tekens invullen",
      "MAXLENGTH_LABEL": "Aantal tekens",
      "MAXLENGTH_PLACEHOLDER": "Onbeperkt",
      "MAXLENGTH_SUMMARY": "Karakters max.",
      "OPTIONS": {
        "ADD_OPTION": "Toevoegen van een optie",
        "ADD_OTHER": "Voeg \"Andere\" toe",
        "OR": "of",
        "OTHER": "Andere"
      },
      "OPTION_LABEL": "Optie {index}",
      "PLACEHOLDER": "Uw antwoord",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Weergeven als het antwoord op ...",
        "OPERATOR": {
          "BLANK": "is leeg",
          "CONTAINS": "bevat",
          "EQ": "is",
          "GT": "is groter dan",
          "GTE": "is groter dan of gelijk aan",
          "LT": "is minder dan",
          "LTE": "is kleiner dan of gelijk aan",
          "NOT_CONTAINS": "bevat niet",
          "NOT_EQ": "is niet",
          "PRESENT": "is niet leeg"
        },
        "OPERATOR_LABEL": "Operator",
        "OPTIONS_LABEL": "Opties",
        "QUESTION_LABEL": "Vraag",
        "TITLE": "Weergave van de vraag"
      },
      "QUESTION_LINKS_SUMMARY": "Weergavevoorwaarde",
      "REQUIRED": "Verplicht",
      "REQUIRED_QUESTION": "Vraag verplicht",
      "SUBMIT_FORM": "Indienen",
      "SURVEY_DESCRIPTION_1": "De vragenlijst komt overeen met de vragen die u aan uw gebruikers wilt stellen.",
      "SURVEY_DESCRIPTION_2": "Stel de vragenlijst in op basis van uw raadpleging.",
      "SURVEY_TITLE": "Agenda",
      "TITLE_LABEL": "Vraag",
      "TITLE_PLACEHOLDER": "Wat is uw leeftijd?",
      "TYPES": {
        "ATTACHMENT": "Bijlagen",
        "CHECKBOX": "Meerdere antwoorden",
        "DATE": "Datum",
        "LOCATION": "Vertaling",
        "MONEY": "Begroting",
        "PHONE_NUMBER": "Nummer van telefoon",
        "PICTURE": "Omslagafbeelding",
        "RADIO": "Uniek antwoord",
        "SECTION": "Sectie",
        "TEXT": "Korte antwoord",
        "TEXTAREA": "Paragraaf",
        "TITLE": "Veldtype"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "U hebt al antwoorden verzameld voor deze vraag.",
        "DESCRIPTION_2": "Als je het wijzigt, worden de bijbehorende antwoorden permanent verwijderd.",
        "DESCRIPTION_3": "Heeft u deze gegevens nodig? Exporteer uw antwoorden voordat u deze vraag en/of optie verwijdert.",
        "TITLE": "Bent u zeker?"
      }
    },
    "GENERAL_INFO": "Algemene informatie",
    "IMAGE": "Afbeelding",
    "LOCALISATION_LABEL": "Locatie of adres",
    "LOCALISATION_MARKER_PLACED": "Markering geplaatst",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Duidelijk",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Klik op de kaart om de markering te plaatsen.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Valideren",
    "LOCALISATION_MODAL_TITLE": "Voeg een locatie toe",
    "LOCALISATION_NO_RESULTS": "Typ alstublieft om suggesties te krijgen",
    "LOCALISATION_PLACEHOLDER": "Voeg een locatie toe",
    "LOCALISATION_SEE_MAP": "Bekijk kaart",
    "MODERATABLE": {
      "LABEL": "Modération voor publicatie",
      "TOOLTIP": "Alle bijdragen moeten worden goedgekeurd door een beheerder voordat ze worden gepubliceerd en zichtbaar zijn voor andere gebruikers."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Formuleer een beschrijving die de aangetroffen anomalie en de aard ervan specificeert. Contextualiseren om de behandeling ervan te vergemakkelijken.",
        "MODAL_DESCRIPTION": "{spaceName} zal u zo snel mogelijk antwoorden.",
        "MODAL_TITLE": "Gefeliciteerd, de anomalie is verzonden!",
        "SIDEBAR_ACTION": "Sturen",
        "SIDEBAR_DESCRIPTION": "Onze organisatie staat voor u klaar en antwoordt zo snel mogelijk op uw vraag.",
        "TITLE": "Iets afwijkends melden",
        "TITLE_PLACEHOLDER": "Ik wil graag aangeven dat…"
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Presenteer een actueel onderwerp of zet een initiatief in de kijker om regelmatig te informeren over nieuwe maatregelen en om educatieve informatie te verspreiden.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers van deze ruimte. {isPrivateSpace, select, true {} other {Deel het op sociale netwerken om het nog meer zichtbaarheid te geven.}}",
        "MODAL_TITLE": "Gefeliciteerd, het artikel is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Beschrijf in één zin uw artikel om mensen enthousiast te maken om het te lezen.",
        "TITLE": "Maak een artikel aan",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Geef nadere informatie over de achtergrond van deze raadpleging. Leg uit hoe de gebruikers zullen worden betrokken, zodat zij op een zinvolle manier kunnen deelnemen aan het zoeken naar oplossingen.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers. Pin het op je startpagina om het prominent te tonen voor nog meer zichtbaarheid.",
        "MODAL_TITLE": "Gefeliciteerd, de oproep voor overleg is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Geef gebruikers een reden om mee te doen in één zin.",
        "SIDEBAR_ACTION": "Publiceren",
        "TITLE": "Het creëren van een overleg",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Verduidelijk de context van het bericht door elk element aan te geven dat kan bijdragen tot een beter begrip van uw onderwerp.",
        "MODAL_CTA": "Bekijk mijn berichten",
        "MODAL_DESCRIPTION": "De ontvanger zal zo snel mogelijk een melding ontvangen. U kunt dit bericht op elk moment terugvinden in het menu \"Mijn berichten & afwijkingen\" van uw profiel.",
        "MODAL_TITLE": "Gefeliciteerd, het bericht is verzonden!",
        "SIDEBAR_ACTION": "Sturen",
        "SIDEBAR_DESCRIPTION": "Dit bericht is privé. Alleen de gebruiker en de admins kunnen het zien.",
        "TITLE": "Stuur een bericht",
        "TITLE_PLACEHOLDER": "Ik wil graag informatie over…"
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "In dit gedeelte kunt u uitleggen hoe gebruikers uw evenement kunnen bijwonen: datum en locatie (adres en/of link naar een online vergadering).",
          "TITLE": "Hoe te bereiken"
        },
        "DESCRIPTION_PLACEHOLDER": "Presenteer de context van het evenement en informeer gebruikers over de voorwaarden om er te komen.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers. Deel het op sociale netwerken om het nog meer zichtbaarheid te geven.",
        "MODAL_TITLE": "Gefeliciteerd, het evenement is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Beschrijf in één zin uw evenement om mensen enthousiast te maken om het te lezen.",
        "SIDEBAR_ACTION": "Publiceren",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Geef details over de achtergrond van dit dossier. Leg uit hoe de gebruikers zullen worden betrokken, zodat zij op een zinvolle manier kunnen deelnemen aan het zoeken naar oplossingen.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers. Pin het op je startpagina om het prominent te tonen voor nog meer zichtbaarheid.",
        "MODAL_TITLE": "Gefeliciteerd, het dossier is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Toevoegen van een inspirerende zin over uw dossier.",
        "SIDEBAR_ACTION": "Publiceren",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Leg uw bijdrage en werking uit.",
        "MODAL_CTA": "Zie mijn bijdragen",
        "MODAL_DESCRIPTION": "Vind al uw bijdragen in uw profiel.",
        "MODAL_DESCRIPTION_GUEST": "Om zijn voortgang te volgen en updates te ontvangen, maak een account aan. Zonder registratie kun je de impact niet meer zien en word je niet op de hoogte gebracht van stemmen en opmerkingen.",
        "MODAL_TITLE": "Bedankt voor uw deelname",
        "REDIRECT": "Deze link lijkt niet te werken. Vind de raadpleging in de lijst om een bijdrage te kunnen leveren.",
        "TITLE": "Invullen van het formulier",
        "TITLE_PLACEHOLDER": "We konden …",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "Publiceren",
          "SIDEBAR_DESCRIPTION": "Zodra gepubliceerd, kunnen andere gebruikers uw bijdrage verrijken door suggesties te doen."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Indienen",
          "SIDEBAR_DESCRIPTION": "De bijdrage wordt gepubliceerd zodra deze is goedgekeurd door de diensten."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Geef details over de context van deze oproep tot bijdragen. Leg de deelnamevoorwaarden uit zodat gebruikers op een relevante manier kunnen deelnemen aan het zoeken naar oplossingen.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers. Pin het op je startpagina om het prominent te tonen voor nog meer zichtbaarheid.",
        "MODAL_TITLE": "Gefeliciteerd, de oproep tot bijdragen is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Geef gebruikers op een aantrekkelijke manier de motivatie om deel te nemen.",
        "SIDEBAR_ACTION": "Publiceren",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Geef details over de achtergrond van deze participatieve begroting. De participatiemodaliteiten toelichten zodat de gebruikers op een zinvolle manier kunnen deelnemen aan het zoeken naar oplossingen.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers. Pin het op je startpagina om het prominent te tonen voor nog meer zichtbaarheid.",
        "MODAL_TITLE": "Gefeliciteerd, de oproep voor participatief budget is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Geef gebruikers in één zin de motivatie om deel te nemen.",
        "SIDEBAR_ACTION": "Publiceren",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "STUDIES": {
        "DESCRIPTION": "De enquête komt overeen met het formulier dat buiten het platform is gemaakt op Typeform, Google Form, Survey Monkey, Tally of elk ander platform dat formulieren maakt.",
        "DESCRIPTION_PLACEHOLDER": "Geef details over de context van deze raadpleging en over de participatiemogelijkheden.",
        "FORM_DESCRIPTION": "Voeg de links van uw enquête toe om deze te delen op uw platform.",
        "MODAL_DESCRIPTION": "Het is nu zichtbaar voor andere gebruikers. Deel het op sociale netwerken om het nog meer zichtbaarheid te geven.",
        "MODAL_TITLE": "Gefeliciteerd, de enquête is gepubliceerd!",
        "PROBLEMATIC_PLACEHOLDER": "Geef gebruikers een reden om deel te nemen in één zin.",
        "SIDEBAR_ACTION": "Publiceren",
        "STUDY_ID_PLACEHOLDER": "Voorbeeld: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Voorbeeld: https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Enquêteresultaten",
        "STUDY_TITLE": "Rapport URL",
        "TITLE_PLACEHOLDER": "Schrijf een titel die de interesse van de gebruikers zal wekken."
      },
      "TITLE": {
        "ANOMALY": "Een anomalie creëren",
        "COMMUNICATION": "Nieuws maken",
        "CONSULTATION": "Een consultatie maken",
        "DEMAND": "Een bericht maken",
        "FOLDER": "Map aanmaken",
        "IDEA": "Een bijdrage maken"
      }
    },
    "POST_PUBLISHED": "Deze inhoud wordt nu gepubliceerd.",
    "POST_PUBLISHED_AT": "Gepubliceerd op {date} om {time}",
    "POST_SAVED": "Deze inhoud is nu opgenomen.",
    "POST_SCHEDULED": "Deze inhoud is gepland voor {date} om {time}.",
    "PROBLEMATIC": "Vangst",
    "PUBLICATION_CANCELLED": "De publicatie is geannuleerd.",
    "SIMILAR_PROPOSALS": "Andere gebruikers lijken vergelijkbare bijdragen te hebben gedeeld:",
    "START_AT": "Startdatum en tijd",
    "STEPS": {
      "CONFIGURATION": "Configuratie van de fase",
      "DESCRIPTION": "In deze rubriek kunt u de belangrijkste data van de raadpleging aan de gebruikers meedelen.",
      "DESCRIPTION_TABS": "Stap meertalige beschrijving tabbladen",
      "END_AT_HELPER_TEXT": "Optioneel voor doorlopende stappen",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Denk eraan om de \"Resultatenlink\" toe te voegen en de configuratie te controleren om de optie in te schakelen.",
        "ADMIN_ONLY_TEXT": "Weergave van de resultaten van de raadpleging",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "Het volledige verslag bevat alle resultaten van de enquête, vraag per vraag. Dit is een belangrijk element van transparantie voor de gebruikers.",
          "ADMIN_ONLY_TEXT": "Weergave van de raadplegingsresultaten"
        }
      },
      "PLACEHOLDER": "Leg uit hoe deze stap werkt.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "Alle gebruikers kunnen bijdragen plaatsen in de raadpleging. Als de optie is uitgeschakeld, kunnen alleen beheerders nieuwe bijdragen maken.",
        "ADMIN_ONLY_TEXT": "Repository open voor gebruikers"
      },
      "TITLE": "Configuratie van de rol"
    },
    "TITLE": "Titel",
    "UNDERSTOOD": "Begrepen!",
    "VIDEO": "Vidéo",
    "VIDEO_HELPER": "U kunt alleen een Youtube of een Vimeo video delen.",
    "VIDEO_LABEL": "Link naar een video",
    "VIDEO_PLACEHOLDER": "Voorbeeld: http://www.youtube.com/watch?=id of http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Stemmen (voor) beperken tot het eerder gedefinieerde budget van {count}",
        "TITLE": "Budgetbeperking"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Maximaal aantal stemmen",
        "MIN_LABEL": "Minimaal aantal stemmen",
        "TITLE": "Aantal toegewezen ondersteuningen"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Gebruikers kunnen bijdragen ondersteunen totdat het totale budget is uitgeput. Bijdragen moeten worden gebudgetteerd.",
          "NAME": "Per enveloppe"
        },
        "DOUBLE": {
          "DESCRIPTION": "Gebruikers kunnen bijdragen op een positieve of negatieve manier ondersteunen. Het wordt vaak gebruikt in het geval van oproepen tot bijdragen of reacties.",
          "NAME": "Voor of tegen"
        },
        "SINGLE": {
          "DESCRIPTION": "Gebruikers kunnen alleen positief bijdragen ondersteunen. Deze module wordt vaak gebruikt als uw raadpleging een stemfase heeft.",
          "NAME": "Voor"
        },
        "SUBTITLE_1": "De stemregels stellen gebruikers in staat om de bijdragen die zijn geleverd aan uw raadpleging te ondersteunen.",
        "SUBTITLE_2": "Configureer de algemene voorwaarden op maat van je project.",
        "TITLE": "Stemopties"
      },
      "UNLIMITED": "Onbeperkt"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Analyse",
      "CONTRIBUTION": "Bijdrage",
      "IMPLEMENTATION": "Resultaten",
      "SUBMISSION": "Indiening",
      "VOTE": "Stemmen"
    },
    "STUDY": {
      "IMPLEMENTATION": "Resultaten",
      "SUBMISSION": "Antwoord"
    }
  },
  "PREVIOUS": "Vorige",
  "PROFILE": {
    "ADDRESS": "Gemeente",
    "BIRTHDATE": "Geboortedatum",
    "CROSS_SPACES_WARNING": "De onderstaande informatie heeft betrekking op alle ruimtes waar u lid van bent geworden.",
    "FIRST_NAME": "Voornaam",
    "LAST_NAME": "Achternaam",
    "NAME_IS_PRIVATE": "Andere gebruikers zullen u zien als: {displayName}",
    "NATIONAL_ID": "Nationaal registratienummer",
    "PRIVATE_INFORMATION_NOTICE": "Deze informatie wordt alleen gebruikt voor statistische doeleinden met betrekking tot deelname.",
    "PROFILE_UPDATED": "Bijgewerkt profiel.",
    "SEX": "Seks",
    "SEX_FEMALE": "Vrouw",
    "SEX_HELPER": "Zoals vermeld op uw identiteitskaart. Deze gegevens worden, eenmaal geaggregeerd, vergeleken met de statistieken verstrekt door nationale instituten of door de organisatie zelf.",
    "SEX_MALE": "Man",
    "SEX_UNSPECIFIED": "Niet gespecificeerd",
    "SOCIOPROFESSIONAL_CATEGORY": "Sociale- en beroepscategorie",
    "TITLE": "Mijn profiel"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Voordat je deze inhoud kunt publiceren, moet je {link} naar het formulier",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "voeg vragen toe",
    "PARENT_WARNING": "Voordat u deze inhoud kunt publiceren, moet u {link} publiceren.",
    "PUBLISH": {
      "BUTTON": "Publiceer nu",
      "CONTENT": "Wilt u echt publiceren?",
      "NO": "Nee",
      "TOAST": "Dit bericht is gepubliceerd.",
      "YES": "Ja, publiceren"
    },
    "SCHEDULE": {
      "BUTTON": "De publicatie plannen",
      "CONTENT": "Wil je echt plannen?",
      "NO": "Geen",
      "TOAST": "Dit inhoud is gepland.",
      "YES": "Ja, plannen"
    },
    "UNPUBLISH": {
      "BUTTON": "Ongedaan maken",
      "CHILDREN_WARNING": "Door deze inhoud te unpublishen, zal alles wat het bevat ook unpublishen ({childrenCount}).",
      "CONTENT": "Wilt u echt publicatie ongedaan maken?",
      "NO": "Nee",
      "TOAST": "Dit inhoud is niet langer beschikbaar.",
      "YES": "Ja, ongepubliceerd maken"
    },
    "UNSCHEDULE": {
      "BUTTON": "Geannuleerd de planning",
      "CONTENT": "Wilt u de planning echt annuleren?",
      "NO": "Nee",
      "TOAST": "De planning van deze inhoud is geannuleerd.",
      "YES": "Ja, annuleer de planning."
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {Geen antwoord} one {{count} antwoord} other {{count} antwoorden}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Zoeken",
    "CATEGORIES_PLACEHOLDER": "Filter op thema",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Begin met het typen van trefwoorden in de zoekbalk.",
      "NO_RESULTS": "Zorg ervoor dat je alles juist spelt. U kunt ook proberen uw zoekopdracht in te korten of anders te formuleren."
    },
    "INPUT_PLACEHOLDER": "Zoeken",
    "RESULTS_COUNT": "{count, plural, =0 {Geen resultaten} one {{count} resultaat} other {{count} resultaten}}",
    "TYPES_PLACEHOLDER": "Filter op inhoudstype"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Terug naar de consultatie",
    "BIRTHDATE": {
      "TITLE": "Geboortedatum"
    },
    "CSAM": {
      "TITLE": "CSAM Login"
    },
    "CTA": "Deelnemen",
    "DESCRIPTION": "<b>Dit consult is beveiligd.</b> Om toegang te krijgen, moet u de onderstaande gegevens valideren en de ontbrekende gegevens invullen.<conditional> U kunt te allen tijde uw recht op toegang, rectificatie en verwijdering van deze gegevens uitoefenen door contact op te nemen met dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Helaas kunt u met de door u opgegeven informatie niet deelnemen aan de raadpleging. Corrigeer uw gegevens of ga terug naar de raadpleging.",
      "TITLE": "Dimensies"
    },
    "INLINE_DESCRIPTION": "<b>Deze raadpleging is beveiligd.</b> Om toegang te krijgen, moet u de benodigde gegevens verstrekken. Op elk moment kunt u uw rechten op toegang, rectificatie en verwijdering van deze gegevens uitoefenen via de pagina van uw profiel als u een account heeft of per e-mail via dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "U moet een geldig registratienummer met 11 cijfers invoeren.",
      "TITLE": "Belgische nationale identiteit"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Uw deelname wordt pas in overweging genomen <b>na verificatie van uw documenten</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Terug (Enkel nieuwe identiteitskaart)",
      "FORM": {
        "DESCRIPTION": "Geef de voor- en achterkant van uw identiteitsbewijs (JPEG, JPG, PNG, HEIC, WEBP of PDF-formaat, aanbevolen maximale grootte 2MB).<br></br><br></br>Alleen het volgende wordt geaccepteerd:<ul><li>Nationale identiteitskaart</li><li>Frans paspoort</li><li>Rijbewijs (nieuw formaat, formaat creditcard)</li></ul>",
        "GENERIC_ERROR": "Er is een fout opgetreden tijdens het uploaden van uw documenten. Controleer uw verbindingsstatus of probeer het later nog eens. U kunt ook proberen het document te verkleinen (aanbevolen maximale grootte 2MB).",
        "SUCCESS_TOAST": "Uw identiteit is succesvol geverifieerd."
      },
      "FRONT": "Voor",
      "NO": "Geen",
      "TITLE": "Identiteitsbewijs",
      "YES": "Ja"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Enkel de volgende documenten worden geaccepteerd: <ul><li>Recente elektriciteits-, gas- of waterrekening</li><li>Vaste of mobiele telefoonrekening</li><li>Salarisstrookje</li><li>Verklaring van woningverzekering (brand, huurdersrisico’s of aansprakelijkheid)</li><li>Stempas</li><li>Aanslagbiljet</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "Je moet eerst je identiteitsbewijs valideren voordat je je bewijs van adres kunt sturen.",
      "DESCRIPTION": "Gelieve een bewijs van adres te verstrekken (in JPEG, JPG, PNG, HEIC, WEBP of PDF formaat, aanbevolen maximale grootte 2MB).",
      "DOCUMENT_CONFIRMATION": "Na verificatie door onze teams wordt er een e-mail naar u verzonden om uw deelname te bevestigen.",
      "TITLE": "Bewijs van adres"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "Deze waarde is onjuist."
    },
    "SIGNUP_INVITATION": "Als u een <b>bevestigingsmail</b> van uw deelname wilt ontvangen en uw documenten wilt opslaan, maak dan een account aan.",
    "SUCCESS": "Je vous remercie pour votre participation.",
    "TOOLTIP": "Deze raadpleging is beveiligd en vereist bepaalde informatie om deel te nemen.",
    "VALIDATED_INLINE_DESCRIPTION": "We hebben je identiteit gevalideerd als <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Accountverificatie"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Beveiligingsvragen weergeven",
    "FORM_BUILDER": {
      "DESCRIPTION": "Beveiligingsvragen zijn toegangscontrolemiddelen.<br></br> Ze maken het mogelijk om te verifiëren of deelnemers aan bepaalde voorwaarden voldoen voordat ze bijdragen, stemmen, reageren of antwoorden op een enquête (bijvoorbeeld: toegangscode, nationaal ID, inwoner van een bepaald gebied, etc.).",
      "TITLE": "Beveiligingsvragen"
    },
    "OPTION_1": {
      "DESCRIPTION": "Geen registratie vereist om deel te nemen",
      "TITLE": "Voeg toe aan de kalender"
    },
    "OPTION_2": {
      "DESCRIPTION": "Gebruikers moeten zich registreren om deel te nemen",
      "TITLE": "Aanmeldingen"
    },
    "OPTION_3": {
      "DESCRIPTION": "Gebruikers moeten hun account verifiëren om deel te nemen.",
      "TITLE": "Geverifieerde inschrijvingen"
    },
    "OPTION_4": {
      "DESCRIPTION": "De opslagplaats is gesloten voor gebruikers.",
      "TITLE": "Beheerders"
    },
    "WHO_CAN_COMMENT": "Wie kan reageren?",
    "WHO_CAN_RESPOND_SURVEY": "Wie kan de enquête beantwoorden?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "Wie kan een bijdrage indienen?",
    "WHO_CAN_VOTE": "Wie mag stemmen?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Verbindingsinstellingen",
      "DATA_SHARED_WITH_SPACE": "Mijn delen",
      "LANGUAGE": "Taal",
      "PASSWORD": "Wachtwoord (minimaal 12 tekens)",
      "VERIFIED": "Gecontroleerd",
      "VERIFIED_EMAIL": "E-mail geverifieerd"
    },
    "COOKIES": {
      "DESCRIPTION": "De volgende “functionele” cookies maken specifieke en optionele functies op Fluicity Engage mogelijk om uw gebruikerservaring te verbeteren.",
      "FACEBOOK": {
        "DESCRIPTION": "Hiermee kunt u inloggen op uw deelnemingsruimte met uw Facebook-account.",
        "TITLE": "Facebook Connect"
      },
      "GOOGLE": {
        "DESCRIPTION": "Hiermee kunt u inloggen op uw deelnemergedeelte met uw Google-account.",
        "TITLE": "Google Sign-in"
      },
      "TITLE": "Mijn cookievoorkeuren",
      "VIMEO": {
        "DESCRIPTION": "Hiermee kunt u video's die gehost worden op Vimeo rechtstreeks vanuit uw deelnemingsruimte bekijken.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Hiermee kunt u video's die gehost worden op Youtube rechtstreeks vanuit uw deelnemingsruimte bekijken.",
        "TITLE": "Youtube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Ja, verwijder mijn accountt",
      "CTA": "Verwijder mijn account",
      "TITLE": "Wilt u echt uw Fluicity Engage account verwijderen?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "Om u opnieuw in te schrijven, of u uit te schrijven voor één of meer soorten meldingen, gebruikt u de onderstaande instellingen. U kunt deze parameters openen wanneer u maar wilt vanuit de instellingen van uw account.",
        "SUCCESS_TITLE": "U heeft zich succesvol uitgeschreven voor alle meldingen."
      }
    },
    "JOIN_SPACE": "Deelnemen aan {spaceName}",
    "LANGUAGE": {
      "LABEL": "Taal"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Ja, ruimte laten",
      "CTA": "Verlaat {spaceName}",
      "DESCRIPTION": "Door dit gebied te verlaten, ontvangt u geen meldingen meer met betrekking tot consultaties of nieuws en kunt u geen nieuwe bijdragen meer leveren, commentaar geven, stemmen, enz.",
      "TITLE": "Weet je zeker dat je {spaceName} wilt verlaten?"
    },
    "NO_SPACES": "U volgt geen enkele ruimte.",
    "PASSWORD": {
      "CONFIRMATION": "Bevestiging wachtwoord",
      "CREATE": "Aanmaken",
      "CREATE_INPUT": "Wachtwoord aanmaken",
      "CREATE_MESSAGE": "U heeft nog geen wachtwoord ingesteld",
      "CURRENT": "Huidig wachtwoord",
      "DIALOG": {
        "CREATE_TITLE": "Wachtwoord aanmaken",
        "SUBTITLE_2": "Voer uw huidige wachtwoord en uw nieuwe wachtwoord in:",
        "TITLE": "Wachtwoord wijzigen",
        "VALIDATE": "Bevestig"
      },
      "ERROR_LOGIN": "Aanmeldingsfout.",
      "FORGOT_PASSWORD": "Wachtwoord vergeten?",
      "NEW": "Nieuw wachtwoord",
      "PLACEHOLDER": "Wachtwoord",
      "SHORT_PASSWORD": "de afmeting van het wachtwoord niet kleiner zijn dan {length}",
      "SUCCESS": "Het nieuwe wachtwoord is geregistreerd.",
      "UPDATE": "Wijzigen",
      "WRONG_PASSWORD": "Het wachtwoord moet ten minste 6 tekens lang zijn."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Toegang tot mijn persoonlijke gegevens vragen",
        "EMAIL_BODY": "Hallo,\n\nIn overeenstemming met het privacybeleid voor persoonlijke gegevens van de Fluicity Engage-oplossing, zou ik graag een export ontvangen van alle persoonlijke gegevens die zijn gekoppeld aan mijn account ({userEmail}) die op het platform wordt gehost.\n\nMet vriendelijke groet,\n\n{userName}",
        "EMAIL_SUBJECT": "Verzoek om gegevensoverdraagbaarheid"
      },
      "TITLE": "Privacy en persoonsgegevens"
    },
    "REQUIRED_DIMENSION_INFO": "Bepaalde informatie is vereist voor deelname aan dit gebied. Om uw recht op verwijdering uit te oefenen, laat u gewoon de ruimte.",
    "SPACE_SELECTION": "Keuze van de ruimte",
    "TABS": {
      "INFO": "Mijn gegevens",
      "MY_SPACE": "Mijn ruimte",
      "NOTIFICATIONS": "Mijn kennisgevingen",
      "SETTINGS": "Mijn instellingen"
    }
  },
  "SIGN_IN": "Meedoen",
  "SIGN_OUT": "Uitloggen",
  "SIGN_UP": {
    "EMAIL": "E-mail",
    "LOCATION_LABEL": "Gemeente van verblijf",
    "LOCATION_PLACEHOLDER": "Voorbeeld: Brussel",
    "PRIVACY": "Privacy beleid",
    "TERMS": "Gebruiksvoorwaarden"
  },
  "SORT": {
    "COMMENTED": "Het meest becommentarieerd",
    "LEAST_EXPENSIVE": "De goedkoopste",
    "POPULAR": "De meest populaire",
    "RANDOM": "Willekeurig",
    "RECENT": "De meest recente",
    "UPVOTED": "De meest gestemde"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {consultatie gestart} one {consultatie gestart} other {consultaties gestart}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {bijdrage gerealiseerd} one {bijdrage gerealiseerd} other {bijdragen gerealiseerd}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {deelneming} one {deelneming} other {deelnemingen}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {geregistreerden} one {geregistreerde} other {geregistreerden}}"
      },
      "TITLE": "Algemeen"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "Hier vindt u de dossiers, oproepen voor bijdragen, participatieve begrotingen en enquêtes die zijn gepubliceerd door de organisatie.",
      "TITLE": "{count, plural, =0 {Geen raadplegingen} one {{count} raadpleging} other {{count} raadplegingen}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "U zult hier uw berichten en anomalieën vinden.",
        "TITLE": "Mijn berichten en anomalieën"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "Hier vindt u uw bijdragen.",
        "TITLE": "Mijn bijdragen"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Adres",
      "ADDRESS_PLACEHOLDER": "Een adres zoeken",
      "ADMINISTRATORS": "Beheerders",
      "BRAND_LOGO_LABEL": "Ruimte logo",
      "BRAND_LOGO_TOOLTIP": "Het space-logo verschijnt linksboven op het platform, in de navigatie en in de e-mails.",
      "COLOR_LABEL": "Kleur",
      "COLOR_PLACEHOLDER": "Kleur",
      "DECISION_MAKER_FIRST_NAME_LABEL": "Voornaam van de sponsor",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Stel de voornaam in",
      "DECISION_MAKER_LAST_NAME_LABEL": "Naam van de sponsor",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Stel de achternaam in",
      "DECISION_MAKER_PICTURE_LABEL": "Profielfoto van de sponsor",
      "DECISION_MAKER_ROLE_LABEL": "Rol van de sponsor",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Beschrijf de rol van de sponsor in uw organisatie",
      "DESCRIPTION_HELPER": "De meta-beschrijvingstag stelt zoekmachines in staat een voorbeeld te krijgen van de inhoud van de pagina's die worden weergegeven tijdens een zoekopdracht.",
      "DESCRIPTION_LABEL": "Meta beschrijving",
      "DESCRIPTION_PLACEHOLDER": "Zorg voor een korte en pakkende tekst om te begroeten en te betrekken",
      "EMAIL_LABEL": "E-mail",
      "EMAIL_PLACEHOLDER": "email@monsite.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/mijnpagina",
      "FAVICON_LABEL": "Favicon",
      "FAVICON_TOOLTIP": "De favicon is het pictogram dat in de browsertabbladen verschijnt om uw site gemakkelijker te herkennen.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/mijnpagina",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Adres: 210 avenue Jean Jaurès, 69007 Lyon, Frankrijk",
        "COMPANY_EMAIL": "E-mail: info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Telefoon: +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "Site gehost door: Amazon Web Services (AWS) in Parijs, Frankrijk",
        "HOSTING": "Hosting",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Hosting en technische oplossing",
        "HOST_ADDRESS": "Adres van de host: 38 avenue John F. Kennedy, L-1855 Luxemburg",
        "PLATFORM_HOSTED_BY": "Het platform wordt gehost en aangedreven door Fluicity Engage, een oplossing uitgegeven door het bedrijf Fluicity.",
        "THIRD_PARTY_TRUST": "Fluicity Engage treedt op als een vertrouwde derde partij voor het verzamelen en verwerken van gegevens, in overeenstemming met de AVG."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/mijnpagina",
      "LOCALES": "Talen",
      "LOCALES_HELPER": "Selecteer de talen waarin gebruikers op uw platform kunnen navigeren.",
      "LOCALES_LABEL": "Beschikbare talen",
      "LOCALE_DEFAULT_HELPER": "Selecteer de standaardtaal van uw platform.",
      "LOCALE_DEFAULT_LABEL": "Standaardtaal",
      "LOGO_PICTURE_LABEL": "Profielfoto van de beheerders",
      "LOGO_PICTURE_TOOLTIP": "Wanneer ze een raadpleging, een bijdrage, een bericht maken of commentaar geven op het platform, worden de beheerders geïdentificeerd door deze profielfoto en de naam van de ruimte in plaats van hun eigen foto en naam.",
      "NAME_HELPER": "De naam van de ruimte zal op vele plaatsen worden weergegeven: in de naam van de pagina's, in de e-mails, op de plaats van de namen van de beheerders, enz.",
      "NAME_LABEL": "Naam van de ruimte",
      "NAME_PLACEHOLDER": "Definieer de naam van uw ruimte",
      "PHONE_LABEL": "Téléphone",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Primaire kleur",
      "PRIMARY_COLOR_PLACEHOLDER": "Primaire kleur",
      "SECONDARY_COLOR_LABEL": "Secundaire kleur",
      "SECONDARY_COLOR_PLACEHOLDER": "Secundaire kleur",
      "SPACE_DECISION_MAKER": "Sponsor",
      "SPACE_DECISION_MAKER_TOOLTIP": "De sponsor is een persoonlijkheid in uw organisatie die uw gebruikers motiveert, geruststelt en betrekt.",
      "SPACE_LEGAL_NOTICE": "Wettelijke vermeldingen",
      "SPACE_LEGAL_NOTICE_LABEL": "Beschrijving",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "Deze pagina wordt onderaan uw platform weergegeven, onder de voettekst, met vooraf ingevulde informatie door Fluicity Engage als aanbieder en technische uitgever van de oplossing.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "De juridische vermeldingen informeren de gebruikers over de identiteit van de verantwoordelijke van de site, de host, en de voorwaarden voor het publiceren van het platform.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "Ze zijn verplicht voor elke institutionele of publieke website en versterken de transparantie van uw aanpak.",
      "SPACE_PRIVACY_POLICY": "Privacybeleid",
      "SPACE_PRIVACY_POLICY_LABEL": "Beschrijving",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "Deze pagina wordt onderaan uw platform weergegeven, onder de voettekst, met informatie over Fluicity Engage.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "Het privacybeleid informeert de deelnemers over de verwerking van hun persoonsgegevens. U kunt hier specifieke details toevoegen die van toepassing zijn op uw organisatie (bijv.: specifieke bewaartermijn, contactpersoon DPO, intern gebruik van de gegevens, …).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "Deze tekst vult het <link>privacybeleid van Fluicity Engage</link> aan, de technische beheerder van het platform en garant voor de AVG-naleving. Het toevoegen van uw eigen tekst blijft optioneel afhankelijk van uw gebruik van het platform.",
      "SPACE_TERMS_OF_USE": "Gebruiksvoorwaarden",
      "SPACE_TERMS_OF_USE_LABEL": "Beschrijving",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Voeg hier de inhoud van uw aangepaste gebruiksvoorwaarden toe",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "De gebruiksvoorwaarden stellen de regels vast voor het correct gebruik van uw ruimte, de rechten en verantwoordelijkheden van de gebruikers, evenals uw verplichtingen als organisator van het proces. (bijv. moderatieregels, participatierechten, enz.).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "Deze tekst vult de <link>algemene voorwaarden van Fluicity Engage</link> aan, als vertrouwde derde partij en uitgever van het platform. Het toevoegen van uw eigen tekst blijft optioneel, afhankelijk van uw gebruik van het platform.",
      "TOPICS": "Thema's",
      "TOPICS_DESCRIPTION": "Thema's maken het mogelijk om uw inhoud te categoriseren zodat gebruikers de inhoud kunnen vinden op basis van hun interesses.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/mijnpagina",
      "UPDATED_SUCCESSFULLY": "De ruimte is succesvol bijgewerkt.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Automatisch een melding sturen bij het starten van een raadpleging en voor alle fasen van deelname."
        },
        "TITLE": "Meldingen",
        "WEEKLY": {
          "LABEL": "Gezant een samenvatting van de actualiteiten van de semaine aux inscrits (nieuwe artikelen, nieuwsberichten en relaties voor een deelnemer aan een raadpleging)."
        }
      },
      "WEBSITE_URL_LABEL": "Website",
      "WEBSITE_URL_PLACEHOLDER": "https://www.mijnwebsite.com",
      "YOUR_SPACE": "Uw ruimte"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "Verbonden ruimten",
        "SEE_MORE": "Zie meer ({count})"
      },
      "FOOTER": {
        "TITLE": "Blijf op de hoogte!"
      },
      "SEE": "Zie",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {Geen geregistreerd} one {{count} geregistreerde} other {{count} geregistreerden}}",
        "IDEAS_COUNT": "{count, plural, =0 {Geen deelname} one {{count} deelname} other {{count} deelnames}}"
      },
      "SPONSOR": "Deze ruimte is verbonden met"
    },
    "NEWS": {
      "EMPTY_STATE": "U vindt hier de door de organisatie gepubliceerde artikelen en evenementen.",
      "TITLE": "{count, plural, =0 {Geen nieuws} one {{count} nieuwsbericht} other {{count} nieuws}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Lees het privacybeleid van Fluicity Engage"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Inschrijvingsformulier",
        "TAB_INVITATIONS": "Uitnodigingen"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Meldingen"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Uiterlijk",
        "TAB_LANGUAGES": "Talen",
        "TAB_TOPICS": "Thema's"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Juridische vermeldingen",
        "TAB_PRIVACY_POLICY": "Privacybeleid",
        "TAB_TERMS_OF_USE": "Voorwaarden voor gebruik."
      },
      "PAGES": {
        "TAB_ABOUT": "Over ons",
        "TAB_FOOTER": "Voettekst",
        "TAB_HOME": "Startpagina",
        "TAB_NAVIGATION": "Navigatiebalk"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Lees de gebruiksvoorwaarden van Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "Algemene Informatie",
    "PROF_CATEGORY_ID": {
      "LABEL": "Sociaal-professionele categorie"
    },
    "SECTION": {
      "HEADER": "Inschrijvingsformulier",
      "SUBTITLE1": "Het inschrijvingsformulier is een tool om gebruikersgegevens te verzamelen.",
      "SUBTITLE2": "Configureer de verzamelvelden volgens uw behoeften met inachtneming van de AVG."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Leeftijd"
    },
    "AI": {
      "ACTIONS": "Ambities van de gebruiker:",
      "ACTIONS_TOOLTIP": "Dit overzicht van de gebruikersverwachtingen is gegenereerd door AI. Het heeft als doel om u te helpen bij het interpreteren van de oorspronkelijke bijdragen van de deelnemers. Het is gebaseerd op de onderstaande bijeengebrachte bijdragen.",
      "ADD_CLUSTER": "Voeg toe aan cluster",
      "ADD_SUB_CLUSTER": "Voeg toe aan subcluster",
      "CLUSTER": {
        "SUMMARY": "Thema beschrijving",
        "SUMMARY_PLACEHOLDER": "De beschrijving van het thema",
        "TITLE": "Thema naam",
        "TITLE_PLACEHOLDER": "De themagroepnaam wordt door AI gebruikt om bijdragen te groeperen."
      },
      "DELETE": "Verwijder",
      "DESCRIPTION": "Beschrijving:",
      "EDIT": "Bewerk",
      "EDIT_CLUSTER": "Bewerk het thema",
      "EDIT_SUB_CLUSTER": "Bewerk het subthema",
      "EXPLAIN_AI": "We maken gebruik van kunstmatige intelligentie om de bijdragen van deze raadpleging zorgvuldig te onderzoeken. Ons doel is om ze te categoriseren op basis van hun gelijkenis, zodat we u een beter inzicht kunnen geven in trends, belangrijke aspiraties en opkomende bijdragen. Met deze aanpak kunt u beter begrijpen welke bijdragen naar voren komen en welke meningen naar voren komen binnen deze raadpleging.",
      "GENERATE": "Start de analyse",
      "IDEAS": "Originele bijdragen:",
      "IN_FAVOR": "Voor",
      "MOVE_IDEA": "Verplaats",
      "MOVE_IDEA_TITLE": "Verander het thema of de subthema",
      "OPPOSED": "Tegen",
      "SUB_CLUSTER": {
        "SUMMARY": "Beschrijving van het subthema",
        "SUMMARY_PLACEHOLDER": "De beschrijving van het subthema",
        "TITLE": "Naam van het subthema",
        "TITLE_PLACEHOLDER": "De naam van de subthema-groep wordt door AI gebruikt om bijdragen te groeperen."
      },
      "TOAST": "De AI-analyse is bezig. Dit kan enkele minuten duren."
    },
    "CITIES": {
      "TITLE": "Woonplaats"
    },
    "CLUSTERS": "Thematische groepen",
    "CLUSTERS_TOOLTIP": "De verschillende aspiraties van gebruikers worden door de AI gegroepeerd in een of meer thema's",
    "CLUSTER_OTHER": "Andere",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Voor de laatste 7 dagen"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, 0 {bijdrage} one {bijdrage} other {bijdragen}}",
    "DAY": "Dag",
    "DELIVERABILITY": "Afleverbaarheid",
    "IDEAS_STATUSES": {
      "TITLE": "Status van bijdragen"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {Opmerkingen} one {Commentaar} other {Opmerkingen}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {Antwoord} one {Antwoord} other {Antwoorden}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {Deelnemers} one {Deelnemer} other {Deelnemers}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {Tegenstemmen} one {Stem tegen} other {Tegenstemmen}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {Stemmen voor} one {Stem voor} other {Stemmen voor}}"
    },
    "MONTH": "Maand",
    "NO_DATA": "Er zijn nog geen gegevens beschikbaar.",
    "PARTICIPANTS": {
      "TITLE": "Aantal deelnemers",
      "TOTAL_PARTICIPANTS": "Deelnemers",
      "TOTAL_TARGETED_USERS": "Geregistreerde gebruikers"
    },
    "PARTICIPANTS_PROGRESSION": "Ontwikkeling van de deelnemers",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Acties uitgevoerd door de deelnemers",
      "TOTAL_COMMENTS": "Opmerkingen",
      "TOTAL_IDEAS": "Maak een bijdrage",
      "TOTAL_NO_ACTIONS": "Geen actie",
      "TOTAL_STUDY_ANSWERS": "Antwoorden op studies",
      "TOTAL_VOTES": "Stem"
    },
    "PARTICIPATION_PROGRESSION": "Evolutie van de deelname",
    "PERFORMANCE": "Prestaties",
    "PROF_CATEGORIES": {
      "TITLE": "Sociaal-professionele categorie"
    },
    "REFERRERS": "Verkeersbronnen",
    "SECTIONS": {
      "ACTIVITY": "Activiteit",
      "ENGAGEMENT": "Betrokkenheid",
      "PARTICIPANTS_PROFILE": "Profiel van de deelnemers"
    },
    "SEX": {
      "TITLE": "Seks",
      "TOTAL_": "Niet gespecificeerd",
      "TOTAL_FEMALE": "Vrouw",
      "TOTAL_MALE": "Mannelijk",
      "TOTAL_UNSPECIFIED": "Niet gespecificeerd"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Inschrijvingsdoelstellingen",
      "TOTAL_TARGETED_USERS": "Doelstelling",
      "TOTAL_USERS": "Geregistreerde gebruikers"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Evolutie van de registraties"
    },
    "TAB_AI": "AI Analyse (beta)",
    "TAB_ATTENDEES": "Aanwezigen",
    "TAB_CONTENTS": "Inhoud",
    "TAB_DETAILS": "Details",
    "TAB_EMAILS": "E-mail met de auteur",
    "TAB_LIST": "Lijst",
    "TAB_PARTICIPATION": "Deelname",
    "TAB_PRIVATE_NOTES": "Interne notities",
    "TAB_PROPOSALS": "Bijdragen",
    "TAB_RESPONSES": "Antwoorden",
    "TAB_RESULTS": "Resultaten",
    "TAB_SETTINGS": "Instellingen",
    "TAB_STATS": "Statistieken",
    "TAB_VOTES": "Stemmen",
    "TARGETED_POPULATION": "Bevolking",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Titel",
      "COL_TOTAL": "Deelnemers",
      "SUBTITLE": "Totaal aantal bijdragen, opmerkingen, stemmen of enquêtereacties",
      "TITLE": "Populaire raadplegingen"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Titel",
      "COL_TOTAL": "Bezoekers",
      "COL_TYPE": "Typen",
      "TITLE": "De meest bezochte inhoud"
    },
    "TOTAL_ANSWERS": "{answersCount} van {totalCount} {totalCount, plural, 0 {respondent} one {respondent} other {respondenten}}",
    "TOTAL_BOUNCED": "Teruggestuurd",
    "TOTAL_CLICKED": "Geklikt",
    "TOTAL_COMMENTS": "Opmerkingen",
    "TOTAL_COMMUNICATIONS": "Nieuws",
    "TOTAL_CONSULTATIONS": "Raadplegingen",
    "TOTAL_DELIVERED": "Afgeleverd",
    "TOTAL_IDEAS": "Contributies",
    "TOTAL_OFFLINE_VOTES": "Stemmen offline",
    "TOTAL_ONLINE_VOTES": "Stemmen online",
    "TOTAL_OPENED": "Geopend",
    "TOTAL_PARTICIPANTS": "Deelnemers",
    "TOTAL_REJECTED": "Geweigerd",
    "TOTAL_RESPONDENTS": "Respondenten",
    "TOTAL_SENT": "Verzonden",
    "TOTAL_STUDY_ANSWERS": "Antwoorden op studies",
    "TOTAL_USERS": "Geregistreerde gebruikers",
    "TOTAL_VOTERS": "Stemmers",
    "TOTAL_VOTES": "Stemmen",
    "UNIQUE_VISITS": "Eenmalige bezoeken",
    "USERS_WHO_ANSWERED": "{count} {count, plural, 0 {respondenten} one {respondent} other {respondenten}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Door gebruikers ondernomen acties",
      "TOTAL_COMMENTS": "Opmerkingen",
      "TOTAL_IDEAS": "Maak een bijdrage",
      "TOTAL_NO_ACTIONS": "Geen actie",
      "TOTAL_STUDY_ANSWERS": "Antwoorden op studies",
      "TOTAL_VOTES": "Stem"
    },
    "WEEK": "Week",
    "WORD_CLOUD": "Woordwolk"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length}/{maxLength}",
    "LENGTH_ERROR": "{length}/{maxLength} - Je hebt de karaktergrens overschreden.",
    "LENGTH_ERROR_TEXT": "Je hebt de karaktergrens overschreden."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Carrousel",
    "BUTTON_GROUP": "Wijzigen van de displaymodus",
    "BUTTON_LIST": "Lijst",
    "BUTTON_MAP": "Kaart"
  },
  "TOKENS": "{count, plural, =0 {No Tokens} one {{count} Token} other {{count} Tokens}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Een thema toevoegen",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "Een of meerdere inhoudselementen van uw platform zijn momenteel onder dit thema gecategoriseerd.",
      "DESCRIPTION_2": "Door het te wijzigen of te verwijderen, wijzigt u de classificatie van deze inhoud.",
      "TITLE": "Weet u het zeker?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "Zie de oorspronkelijke tekst",
    "SUCCESS": "De vertaling is succesvol uitgevoerd.",
    "TRANSLATE": "Vertalen",
    "TRANSLATING": "Vertalend…"
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "De blokken stellen u in staat om uw pagina aan te passen door tekst-, afbeeldings- en videoinformatie in de kijker te zetten.",
        "SECTION_HEADER": "Blokken"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "De blokken stellen u in staat om uw pagina aan te passen door tekst-, afbeeldings-, video-informatie en uitgelichte inhoud weer te geven.",
        "SECTION_HEADER": "Blokken"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Een probleem privé melden",
          "TITLE": "Anomalie"
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Tekst, afbeelding en video",
          "TITLE": "Aangepast"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Privé contact via het platform",
          "TITLE": "Berichtenbox"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Uitgelichte, lopende en komende consultaties",
          "TITLE": "Overleg"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Artikel en evenement",
          "TITLE": "Nieuws"
        },
        "FOLDERS": {
          "DESCRIPTION": "Dossier en subdossier",
          "TITLE": "Map"
        },
        "KPIS": {
          "DESCRIPTION": "Aantal inschrijvingen, bijdragen en consultaties",
          "TITLE": "Enkele cijfers"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "Gebruikersparticipatie",
          "TITLE": "Bijdrage"
        },
        "SPACE_INFO": {
          "TITLE": "Bovenste banner"
        }
      },
      "LAYER_ADD_MEDIA": "Media toevoegen",
      "LAYER_ADD_PICTURE": "Foto",
      "LAYER_ADD_VIDEO": "Video",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "De teksten zijn gecentreerd ten opzichte van de media.",
          "LABEL": "Gecentreerd"
        },
        "LEFT": {
          "DESCRIPTION": "De teksten staan links van de media.",
          "LABEL": "Linksaf"
        },
        "RIGHT": {
          "DESCRIPTION": "De teksten staan rechts van de media.",
          "LABEL": "Rechtsaf"
        },
        "TITLE": "Weergave"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "Alle nieuwsberichten",
        "ARTICLE": "Artikel",
        "EVENT": "Evenement",
        "LABEL": "Type",
        "PINNED": "Aanbevolen"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "Alle consultaties",
        "ENDED": "Voltooide consultaties",
        "LABEL": "Type",
        "ONGOING": "Lopende consultaties",
        "PINNED": "Hoofdpunten"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Gestarte consultaties",
        "CONTRIBUTIONS_COUNT": "Gerealiseerde bijdragen",
        "PARTICIPATIONS_COUNT": "Deelnames (bijdragen, enquête-antwoorden, stemmen en ingediende opmerkingen)",
        "TITLE": "Toon het aantal van:",
        "USERS_AND_PARTICIPATIONS_COUNT": "Ingeschrevenen en deelnames",
        "USERS_COUNT": "Ingeschrevenen"
      },
      "LAYER_CTA_LABEL": "Knoplabel",
      "LAYER_CTA_LABEL_PLACEHOLDER": "Wat u op de knop wilt weergeven",
      "LAYER_CTA_URL": "URL van de knop",
      "LAYER_CTA_URL_PLACEHOLDER": "Koppeling naar een pagina of document",
      "LAYER_DESCRIPTION_LABEL": "Beschrijving",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Stel de tekst van het blok vast. Maak het kort en efficiënt.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "Alle dossiers",
        "CHILDREN": "Inhoud van een map",
        "CUSTOM": "Aangepast",
        "SELECT_FOLDER": "Selecteer een map",
        "SELECT_FOLDERS": "Selecteer de mappen",
        "TYPE_LABEL": "Filtertype"
      },
      "LAYER_PICTURE_LABEL": "Foto",
      "LAYER_TITLE_LABEL": "Titel",
      "LAYER_TITLE_PLACEHOLDER": "Definieer een titel voor het blok",
      "SELECTION_DIALOG": {
        "TITLE": "Een blok maken"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Contact opnemen",
      "INVITE": "Uitnodiging",
      "UNREGISTER": "Uitschrijven",
      "UPDATE_ROLE": "De rol bijwerken"
    },
    "EXPORT": "Gebruikersgegevens exporteren",
    "EXPORT_SUCCESS_TOAST": "De export is bezig. U ontvangt een e-mail wanneer deze klaar is.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "Lijst van door komma's gescheiden e-mails",
        "EMAILS_PLACEHOLDER": "Voorbeeld: user1@organisation.com, user2@association.org",
        "MESSAGE_LABEL": "Uitnodigingsbericht",
        "MESSAGE_PLACEHOLDER": "Voer een korte maar toch inspirerende boodschap in waarmee de gebruikers lid willen worden van uw ruimte en bijdragen.",
        "SUCCESS_TOAST": "Gebruikers zijn succesvol uitgenodigd.",
        "TITLE": "Nodig gebruikers uit",
        "WARNING": "Zorg ervoor dat u de toestemming van de gebruikers hebt verzameld voordat u hen een uitnodiging verzendt."
      },
      "DELETE_FORM": {
        "CONTENT": "U staat op het punt om de uitnodiging te annuleren die naar <b>{email}</b> is gestuurd. Wilt u echt doorgaan?",
        "DELETE": "Verwijderen",
        "TITLE": "Uitnodiging verwijderen"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "U staat op het punt om gebruiker “<strong>{userName}</strong>” af te melden van uw deelnemergedeelte.",
      "DESCRIPTION_2": "Als de ruimte privé is, zal de betrokken gebruiker geen toegang meer hebben tot de ruimte. U zult ze opnieuw moeten uitnodigen om deze operatie te annuleren.",
      "DESCRIPTION_3": "Als de ruimte openbaar is, zal de gebruiker niet langer kunnen deelnemen. Hij of zij zal zich opnieuw moeten registreren om deze actie te annuleren.",
      "DESCRIPTION_4": "Wil je doorgaan?",
      "TITLE": "De gebruiker afmelden"
    }
  },
  "USER_AVATAR": "Avatar van de gebruiker",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "Je hebt het maximum aantal stemmen bereikt",
    "MAX_VOTES_WARNING": "{count, plural, =0 {U kunt geen verdere bijdragen ondersteunen} one {U kunt nog <strong># bijdrage</strong> ondersteunen.} other {U kunt nog <strong># bijdragen</strong> ondersteunen.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {U ondersteunt voldoende bijdragen} one {Nog <strong># ondersteuning</strong> nodig om uw deelname te valideren.} other {Nog <strong># ondersteuningen</strong> nodig om uw deelname te valideren.}}",
    "VALID_PARTICIPATION": "Uw deelname is gevalideerd."
  },
  "VIEW_ALL": "Zie alle",
  "VIRUS_SCAN": {
    "CLEAN": "Virusscan is geslaagd",
    "INFECTED": "Geïnfecteerd bestand",
    "INFECTED_ATTACHMENTS_ERROR": "Een document lijkt geïnfecteerd. Verwijder het voordat u opslaat.",
    "NO_SCAN": "Virusscan aan de gang…"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Geboortedatum: {birthdate}",
        "DELETE_VOTE": "Verwijder de stemming",
        "EMPTY": "Niet ingevuld",
        "IMPORTED_AT": "Geïmporteerd op {date}",
        "KEEP_BOTH": "Hou beide behouden",
        "PARTICIPATED_AT": "Deelname op {date}"
      },
      "DESCRIPTION": "De analyse van duplicaten houdt rekening met de voornaam en achternaam van de gebruikers. Om het duplicaat te behandelen, kies de stem die u wilt verwijderen uit de twee deelnames.",
      "FOUND_DUPLICATES": "U heeft <b>{count, plural, one {{count} geïdentificeerde dubbele stemmer} other {{count} geïdentificeerde dubbele stemmers}}</b>. Laatst bijgewerkt <b>{timeAgo}</b>",
      "LOADING": "Vérification bezig…",
      "NO_DUPLICATES": "Geen dubbele items gevonden. Laatste update {timeAgo} geleden",
      "PLACEHOLDER": "Hier vindt u de kiezers die zijn geïdentificeerd als duplicaten.",
      "REFRESH": "Bijwerken",
      "START_CHECK": "Verificatie starten",
      "TITLE": "Dubbele items beheren"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Voer de URL in"
    },
    "PLACEHOLDER": "Begin te typen..."
  }
}